var _defs, _polygon, _g, _path, _path2, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _text, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _circle, _path11, _path12, _path13, _circle2, _circle3, _path14, _text2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAraclar14(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 437.62 270.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{mask:url(#mask);}.cls-10,.cls-12,.cls-14,.cls-16,.cls-18,.cls-2,.cls-20,.cls-22,.cls-24,.cls-26,.cls-28,.cls-30,.cls-32,.cls-4,.cls-6,.cls-8{mix-blend-mode:multiply;}.cls-2{fill:url(#linear-gradient);}.cls-3{mask:url(#mask-2);}.cls-4{fill:url(#linear-gradient-2);}.cls-5{mask:url(#mask-3);}.cls-6{fill:url(#linear-gradient-3);}.cls-7{mask:url(#mask-4);}.cls-8{fill:url(#linear-gradient-4);}.cls-9{mask:url(#mask-5);}.cls-10,.cls-101,.cls-102,.cls-103,.cls-104,.cls-106,.cls-108,.cls-109,.cls-111,.cls-118,.cls-119,.cls-12,.cls-121,.cls-123,.cls-124,.cls-125,.cls-127,.cls-16,.cls-18,.cls-24,.cls-26,.cls-30,.cls-32,.cls-33,.cls-34,.cls-35,.cls-36,.cls-37,.cls-38,.cls-39,.cls-40,.cls-41,.cls-42,.cls-43,.cls-44,.cls-50,.cls-51,.cls-52,.cls-53,.cls-54,.cls-55,.cls-56,.cls-57,.cls-67,.cls-68,.cls-69,.cls-75,.cls-76,.cls-77,.cls-79,.cls-80,.cls-81,.cls-82,.cls-83,.cls-84,.cls-85,.cls-86,.cls-87,.cls-89,.cls-95,.cls-98,.cls-99{fill-rule:evenodd;}.cls-10{fill:url(#linear-gradient-5);}.cls-11{mask:url(#mask-6);}.cls-12{fill:url(#linear-gradient-6);}.cls-13{mask:url(#mask-7);}.cls-14{fill:url(#linear-gradient-7);}.cls-15{mask:url(#mask-8);}.cls-16{fill:url(#linear-gradient-8);}.cls-17{mask:url(#mask-9);filter:url(#luminosity-noclip-17);}.cls-18{fill:url(#linear-gradient-9);}.cls-19{mask:url(#mask-10);}.cls-20{fill:url(#linear-gradient-10);}.cls-21{mask:url(#mask-11);}.cls-22{fill:url(#linear-gradient-11);}.cls-23{mask:url(#mask-12);}.cls-24{fill:url(#linear-gradient-12);}.cls-25{mask:url(#mask-13);}.cls-26{fill:url(#linear-gradient-13);}.cls-27{mask:url(#mask-14);}.cls-28{fill:url(#linear-gradient-14);}.cls-29{mask:url(#mask-15);}.cls-30{fill:url(#linear-gradient-15);}.cls-31{mask:url(#mask-16);}.cls-32{fill:url(#linear-gradient-16);}.cls-118,.cls-124,.cls-33,.cls-59,.cls-62,.cls-71{fill:#010101;}.cls-34{fill:#242629;}.cls-35{fill:url(#linear-gradient-17);}.cls-36{fill:url(#linear-gradient-18);}.cls-37{fill:#37383a;}.cls-38{fill:url(#New_Gradient_3);}.cls-39{fill:url(#New_Gradient_2);}.cls-40{fill:#111416;}.cls-41{fill:url(#New_Gradient_5);}.cls-42{fill:#959ba1;}.cls-43{fill:#3d4145;}.cls-44{fill:url(#New_Gradient_1);}.cls-45{fill:#676357;}.cls-104,.cls-119,.cls-134,.cls-46,.cls-78,.cls-82,.cls-98{fill:#fff;}.cls-47{fill:#dcdadf;}.cls-48{fill:#b4ae9e;}.cls-49{fill:#fdf9f8;}.cls-50{fill:#333;}.cls-51{fill:#79747b;}.cls-52{fill:url(#linear-gradient-19);}.cls-53{fill:url(#linear-gradient-20);}.cls-54{fill:url(#New_Gradient_3-2);}.cls-55{fill:url(#New_Gradient_2-2);}.cls-56{fill:url(#New_Gradient_5-2);}.cls-57{fill:url(#New_Gradient_1-2);}.cls-58{fill:#3e9bd5;}.cls-60{mask:url(#mask-17);}.cls-61{fill:url(#linear-gradient-21);}.cls-118,.cls-62{opacity:0.2;}.cls-117,.cls-124,.cls-63,.cls-66,.cls-67,.cls-71,.cls-78,.cls-98{opacity:0.5;}.cls-63{fill:url(#New_Gradient_98);}.cls-64{mask:url(#mask-18);}.cls-65{fill:url(#linear-gradient-22);}.cls-66{fill:url(#New_Gradient_98-2);}.cls-67{fill:#708a82;}.cls-68{fill:#4b5563;}.cls-69{fill:url(#New_Gradient_64);}.cls-70{fill:url(#linear-gradient-23);}.cls-72{mask:url(#mask-19);}.cls-73{fill:url(#linear-gradient-24);}.cls-74{mask:url(#mask-20);}.cls-75{fill:url(#linear-gradient-25);}.cls-76{fill:#535f6e;}.cls-77{fill:#ccc;}.cls-79{fill:#676767;}.cls-80{fill:#4e4e4e;}.cls-81{fill:#989898;}.cls-83{fill:url(#linear-gradient-26);}.cls-84{fill:#212a2b;}.cls-85{fill:url(#New_Gradient_131);}.cls-86{fill:url(#linear-gradient-27);}.cls-87{fill:url(#linear-gradient-28);}.cls-88{mask:url(#mask-21);}.cls-89{fill:url(#linear-gradient-29);}.cls-90{fill:url(#linear-gradient-30);}.cls-91{mask:url(#mask-22);}.cls-92{fill:url(#linear-gradient-31);}.cls-93{mask:url(#mask-23);}.cls-94{fill:url(#linear-gradient-32);}.cls-117,.cls-95{fill:#e6e6e5;}.cls-96{mask:url(#mask-24);}.cls-97{fill:url(#linear-gradient-33);}.cls-99{fill:#9a1b1f;}.cls-100{mask:url(#mask-25);}.cls-101{fill:url(#linear-gradient-34);}.cls-102{fill:#f16263;}.cls-103{fill:#ed2224;}.cls-104{opacity:0.7;}.cls-105{mask:url(#mask-26);}.cls-106{fill:url(#linear-gradient-35);}.cls-107{mask:url(#mask-27);}.cls-108{fill:url(#linear-gradient-36);}.cls-109{fill:url(#New_Gradient_67);}.cls-110{mask:url(#mask-28);}.cls-111{fill:url(#linear-gradient-37);}.cls-112{mask:url(#mask-29);}.cls-113{fill:url(#linear-gradient-38);}.cls-114{mask:url(#mask-30);}.cls-115{fill:url(#linear-gradient-39);}.cls-116{fill:url(#New_Gradient_119);}.cls-119{opacity:0.8;}.cls-120{mask:url(#mask-31);}.cls-121{fill:url(#linear-gradient-40);}.cls-122{mask:url(#mask-32);}.cls-123{fill:url(#linear-gradient-41);}.cls-125{fill:url(#New_Gradient_71);}.cls-126{fill:#4d4d4d;}.cls-127,.cls-133{fill:#231f20;}.cls-128{font-size:23.75px;letter-spacing:-0.14em;}.cls-128,.cls-134{font-family:Biko-Bold, Biko;font-weight:700;}.cls-129{letter-spacing:-0.06em;}.cls-130{letter-spacing:-0.1em;}.cls-131{letter-spacing:-0.08em;}.cls-132{fill:none;}.cls-134{font-size:24.12px;letter-spacing:-0.08em;}.cls-135{filter:url(#luminosity-noclip-16);}.cls-136{filter:url(#luminosity-noclip-15);}.cls-137{filter:url(#luminosity-noclip-14);}.cls-138{filter:url(#luminosity-noclip-13);}.cls-139{filter:url(#luminosity-noclip-12);}.cls-140{filter:url(#luminosity-noclip-11);}.cls-141{filter:url(#luminosity-noclip-10);}.cls-142{filter:url(#luminosity-noclip-9);}.cls-143{filter:url(#luminosity-noclip-8);}.cls-144{filter:url(#luminosity-noclip-7);}.cls-145{filter:url(#luminosity-noclip-6);}.cls-146{filter:url(#luminosity-noclip-5);}.cls-147{filter:url(#luminosity-noclip-4);}.cls-148{filter:url(#luminosity-noclip-3);}.cls-149{filter:url(#luminosity-noclip-2);}.cls-150{filter:url(#luminosity-noclip);}"), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip",
    x: 210.12,
    y: -10667.28,
    width: 12.05,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 210.12,
    y: -10667.28,
    width: 12.05,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-150"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 216.15,
    y1: 143.77,
    x2: 216.15,
    y2: 140.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#333"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-2",
    x: 23.66,
    y: -10667.28,
    width: 61.63,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    x: 23.66,
    y: -10667.28,
    width: 61.63,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-149"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 84.36,
    y1: 166.58,
    x2: 23.18,
    y2: 166.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-3",
    x: 19.5,
    y: -10667.28,
    width: 48.24,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    x: 19.5,
    y: -10667.28,
    width: 48.24,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-148"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 67.53,
    y1: 185.16,
    x2: 17.95,
    y2: 185.16,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-4",
    x: 25.4,
    y: -10667.28,
    width: 5.74,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    x: 25.4,
    y: -10667.28,
    width: 5.74,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-147"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 28.27,
    y1: 142.11,
    x2: 28.27,
    y2: 137.57,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-5",
    x: 32,
    y: -10667.28,
    width: 14.21,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-5",
    x: 32,
    y: -10667.28,
    width: 14.21,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-146"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 32,
    y1: 120.29,
    x2: 46.21,
    y2: 120.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#010101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-6",
    x: 31.55,
    y: -10667.28,
    width: 14.2,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    x: 31.55,
    y: -10667.28,
    width: 14.2,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-145"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 33.54,
    y1: 120.05,
    x2: 40.57,
    y2: 120.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-7",
    x: 242.42,
    y: -10667.28,
    width: 12.05,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-7",
    x: 242.42,
    y: -10667.28,
    width: 12.05,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-144"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 248.44,
    y1: 146.11,
    x2: 248.44,
    y2: 143.61,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-8",
    x: 37.53,
    y: -10667.28,
    width: 7.54,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    x: 37.53,
    y: -10667.28,
    width: 7.54,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-143"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 41.3,
    y1: 85,
    x2: 41.3,
    y2: 151.55,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-9",
    x: 242.65,
    y: -10667.28,
    width: 62.22,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-9",
    x: 242.65,
    y: -10667.28,
    width: 62.22,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-142"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 273.76,
    y1: 111.03,
    x2: 273.76,
    y2: 85.88,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-10",
    x: 131.94,
    y: -10667.28,
    width: 262.59,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-10",
    x: 131.94,
    y: -10667.28,
    width: 262.59,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-141"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 263.23,
    y1: 208.61,
    x2: 263.23,
    y2: 201.74,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-11",
    x: 33.49,
    y: -10667.28,
    width: 325.2,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-11",
    x: 33.49,
    y: -10667.28,
    width: 325.2,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-140"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 196.1,
    y1: 106.91,
    x2: 196.1,
    y2: 72.59,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-12",
    x: 64.52,
    y: -10667.28,
    width: 96.64,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-12",
    x: 64.52,
    y: -10667.28,
    width: 96.64,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-139"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 112.84,
    y1: 154.15,
    x2: 112.84,
    y2: 205.73,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-13",
    x: 315.14,
    y: -10667.28,
    width: 77.86,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-13",
    x: 315.14,
    y: -10667.28,
    width: 77.86,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-138"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 354.07,
    y1: 154.15,
    x2: 354.07,
    y2: 202.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a1a1a"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-14",
    x: 370.37,
    y: -10667.28,
    width: 51.29,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-14",
    x: 370.37,
    y: -10667.28,
    width: 51.29,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-137"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 396.02,
    y1: 173,
    x2: 396.02,
    y2: 156.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#818181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-15",
    x: 395.95,
    y: -10667.28,
    width: 26.89,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-15",
    x: 395.95,
    y: -10667.28,
    width: 26.89,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-136"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 395.53,
    y1: 176.97,
    x2: 422.66,
    y2: 176.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#818181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-16",
    x: 384.59,
    y: -10667.28,
    width: 24.36,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-16",
    x: 384.59,
    y: -10667.28,
    width: 24.36,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-135"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 396.22,
    y1: 153.8,
    x2: 398.16,
    y2: 147.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#ccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 717.83,
    y1: 1582.7,
    x2: 733.63,
    y2: 1605.26,
    gradientTransform: "translate(-1063.22 -2918.6) scale(1.95)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6e7980"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#242629"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 1333.35,
    y1: 2686.39,
    x2: 1334.45,
    y2: 2687.9,
    gradientTransform: "translate(-35312.53 -71655.77) scale(26.74)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b4bdc2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#37383a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_3",
    x1: 1329.94,
    y1: 2679.75,
    x2: 1328.92,
    y2: 2678.18,
    gradientTransform: "translate(-32166.23 -65338.14) scale(24.46)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#37383a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#1e1e22"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_2",
    x1: 1317.84,
    y1: 2659.63,
    x2: 1319.16,
    y2: 2658.31,
    gradientTransform: "translate(-26324.73 -53609) scale(20.24)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#282c2f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#525b63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#282c2f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_5",
    x1: 1274.34,
    y1: 2579.71,
    x2: 1275.18,
    y2: 2578.04,
    gradientTransform: "translate(-14888.2 -30641.14) scale(11.96)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#5c656c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#535a5d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_1",
    x1: 2168.62,
    y1: 3888.36,
    x2: 2170.95,
    y2: 3885.48,
    gradientTransform: "translate(3722.61 8225.35) rotate(-173.55) scale(1.95)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#3d4145"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 586.57,
    y1: 1582.61,
    x2: 602.37,
    y2: 1605.18,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 1323.76,
    y1: 2686.38,
    x2: 1324.86,
    y2: 2687.89,
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_3-2",
    x1: 1319.45,
    y1: 2679.74,
    x2: 1318.43,
    y2: 2678.17,
    xlinkHref: "#New_Gradient_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_2-2",
    x1: 1305.17,
    y1: 2659.62,
    x2: 1306.49,
    y2: 2658.3,
    xlinkHref: "#New_Gradient_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_5-2",
    x1: 1252.89,
    y1: 2579.7,
    x2: 1253.73,
    y2: 2578.03,
    xlinkHref: "#New_Gradient_5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_1-2",
    x1: 2299.06,
    y1: 3873.69,
    x2: 2301.39,
    y2: 3870.81,
    xlinkHref: "#New_Gradient_1"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-17",
    x: 210.12,
    y: 140.33,
    width: 12.05,
    height: 3.78,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "211.01 142.58 210.12 141.33 210.14 140.85 210.56 140.48 211.22 140.36 215.92 140.33 218.75 140.45 221.45 140.68 221.92 140.84 222.17 141.08 221.92 141.53 220.83 143.12 219.05 143.85 215.95 144.12 212.77 143.61 211.01 142.58 211.01 142.58"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 216.15,
    y1: 143.77,
    x2: 216.15,
    y2: 140.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_98",
    x1: -332.26,
    y1: 1146.1,
    x2: -332.26,
    y2: 1142.72,
    gradientTransform: "matrix(1.05, 0.05, -0.06, 1.3, 637.95, -1327.77)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#010101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-18",
    x: 242.42,
    y: 142.56,
    width: 12.05,
    height: 3.78,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "243.31 144.81 242.42 143.56 242.43 143.08 242.86 142.71 243.52 142.59 248.22 142.56 251.04 142.68 253.75 142.91 254.21 143.07 254.47 143.31 254.22 143.76 253.12 145.35 251.34 146.09 248.25 146.35 245.07 145.84 243.31 144.81 243.31 144.81"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 248.44,
    y1: 146.11,
    x2: 248.44,
    y2: 143.61,
    xlinkHref: "#linear-gradient-21"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_98-2",
    x1: -340.32,
    y1: 1145.97,
    x2: -340.32,
    y2: 1142.59,
    gradientTransform: "matrix(1.05, 0.05, -0.06, 1.3, 678.71, -1324.95)",
    xlinkHref: "#New_Gradient_98"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_64",
    x1: -414.25,
    y1: 496.68,
    x2: -409.56,
    y2: 508.9,
    gradientTransform: "translate(815.13 -330.84) scale(0.97)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#535f6e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#232630"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#424244"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: -423.11,
    y1: 503.77,
    x2: -477.58,
    y2: 503.77,
    gradientTransform: "translate(836.01 -311.15) scale(0.97)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#535f6e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#232630"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#424244"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-19",
    x: 370.37,
    y: 155.04,
    width: 51.29,
    height: 18.09,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M421,173.13a3.06,3.06,0,0,0,.63-.15c-.65,0-1.9.45-1.8-.43h1.64c-.59-1.55-1.4-3.17-2.87-3.83a2.11,2.11,0,0,1-.63-.45,1.86,1.86,0,0,1-.51-.23c-1.14-.72-3.15-5.23-4.06-7.55-.5-1.27-1.42-3.41-2.29-5.45l-5.42.65s-8.11,8-10.51,10.24-7.25,2.26-7.25,2.26l-17.59-2.07a35.2,35.2,0,0,1,3.39,1.92,18.81,18.81,0,0,1,3.37,2.82c6.25.81,18.37,2.27,24.67,2.27Z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 396.02,
    y1: 173,
    x2: 396.02,
    y2: 156.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-20",
    x: 395.95,
    y: 176.62,
    width: 26.89,
    height: 0.71,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M422.25,176.62H398.89c-1.43,0-2.47.19-2.94.7h26.89a1.21,1.21,0,0,0-.59-.7Z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 395.53,
    y1: 176.97,
    x2: 422.66,
    y2: 176.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: -412.81,
    y1: 514.64,
    x2: -412.81,
    y2: 531.55,
    gradientTransform: "translate(806.9 -352.34) scale(0.97)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9eb2b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_131",
    x1: -416.61,
    y1: 513.33,
    x2: -416.61,
    y2: 525.56,
    gradientTransform: "translate(815.32 -346.2) scale(0.97)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#7e8794"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: -421.61,
    y1: 529.97,
    x2: -421.61,
    y2: 514,
    gradientTransform: "translate(805.99 -352.74) scale(0.97)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9eb2b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#212a2b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: -423.16,
    y1: 514,
    x2: -423.16,
    y2: 519.86,
    gradientTransform: "translate(805.99 -352.74) scale(0.97)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#9eb2b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-21",
    x: 384.59,
    y: 146.93,
    width: 24.36,
    height: 9.09,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-31"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M384.59,148.14a3.94,3.94,0,0,1,1.85-.56c2.53-.41,10.89-1.55,14.6.71a23.48,23.48,0,0,1,7.91,7.6c-5.19.48-7.45-.39-10.12-1.76-3.11-1.59-8.48-4.47-14.24-6Z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 396.22,
    y1: 153.8,
    x2: 398.16,
    y2: 147.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: -837.78,
    y1: 505.71,
    x2: -769.97,
    y2: 505.71,
    gradientTransform: "translate(836.01 -311.15) scale(0.97)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#535f6e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#232630"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#424244"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-22",
    x: 23.66,
    y: 165.62,
    width: 61.63,
    height: 1.93,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M24.94,165.72A10.09,10.09,0,0,1,24,167a2.1,2.1,0,0,0-.29.5H84c.43-.2.86-.38,1.29-.56l-17.24-1.36-43.11.1Z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 84.36,
    y1: 166.58,
    x2: 23.18,
    y2: 166.58,
    xlinkHref: "#linear-gradient-25"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-23",
    x: 19.5,
    y: 184.08,
    width: 48.24,
    height: 2.15,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M23.18,184.08l0,.32-1.58.07a3,3,0,0,0-2.06,1.76H67.74l-3.19-2.15Z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 67.53,
    y1: 185.16,
    x2: 17.95,
    y2: 185.16,
    xlinkHref: "#linear-gradient-21"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-24",
    x: 25.4,
    y: 134.36,
    width: 5.74,
    height: 7.81,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M26,134.36a15,15,0,0,0,.2,1.53c.25,1.33-.63,1.54-.7,3.08-.06,1.37-.63,2.7,1.06,2.5l0,.7h2.9c1.36,0,1.22-.14,1.33-.82s0-3.23.28-4.7-.64-1.22-.64-1.22-.4-.11-2.3-.36a5.37,5.37,0,0,1-2.1-.71Z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 28.27,
    y1: 142.11,
    x2: 28.27,
    y2: 137.57,
    xlinkHref: "#linear-gradient-21"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-25",
    x: 32,
    y: 83.31,
    width: 14.21,
    height: 73.95,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M39.94,83.31a95.7,95.7,0,0,0-4.6,21.1c-.9,10.72-2.79,35.78-2.79,40.11S32,157.13,32,157.13s6,2,9.56-9.64,4.69-17.13,4.59-28.84,1.36-31.28-6.21-35.34Z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 32,
    y1: 120.29,
    x2: 46.21,
    y2: 120.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.41
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-26",
    x: 31.55,
    y: 83.31,
    width: 14.2,
    height: 73.95,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M39.48,83.31a96,96,0,0,0-4.59,21.1c-.91,10.72-2.8,35.78-2.8,40.11s-.54,12.61-.54,12.61,5.95,2,9.56-9.64,4.68-17.13,4.59-28.84,1.36-31.28-6.22-35.34Z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 33.54,
    y1: 120.05,
    x2: 40.57,
    y2: 120.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a71e26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a71e26"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-27",
    x: 37.53,
    y: 83.89,
    width: 7.54,
    height: 68.37,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M38.8,83.89s-.55,1.52-1.27,4c7.25,4.39,5.84,23.6,5.94,35.16.08,11.72-1,17.22-4.6,28.84l-.12.36a26.62,26.62,0,0,0,1.67-4.19c3.6-11.63,4.69-17.13,4.59-28.84s1.36-31.28-6.21-35.33Z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 41.3,
    y1: 85,
    x2: 41.3,
    y2: 151.55,
    xlinkHref: "#linear-gradient-25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_67",
    x1: -299.19,
    y1: 457.78,
    x2: -354.22,
    y2: 542.52,
    gradientTransform: "translate(608.94 -379.92) scale(0.97)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#99918f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#424244"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-17",
    x: 242.65,
    y: 82.23,
    width: 62.22,
    height: 31.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-28",
    x: 242.65,
    y: 82.23,
    width: 62.22,
    height: 31.8,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M243.88,108.73c21.45,1.49,42.3,3.31,61,5.3l-1.11-10.6s-1.45-2.89-18.33-12.65-42.78-8.5-42.78-8.5l1.23,26.45Z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 273.76,
    y1: 111.03,
    x2: 273.76,
    y2: 85.88,
    xlinkHref: "#linear-gradient-21"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-29",
    x: 131.94,
    y: 201.55,
    width: 262.59,
    height: 6.92,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M131.94,201.55c.11,1.36.16,2.72.17,4.1a5,5,0,0,0,0,1.59c.3.6,1.78.35,2.63.36,8.73.06,17.45,0,26.18,0q29,.09,57.9.21,27.13.09,54.29.22c9.78,0,19.56,0,29.34.07,2,0,4,0,6,0l3.54.05a1.5,1.5,0,0,1,.72.26,3.22,3.22,0,0,0,.8-.23c2,0,4,.1,6,.1,1,0,1.91,0,2.87,0,.8,0,.51-.89.51-1.59,0-1.78,0-3.49.06-5.18Zm253.57,0a6.7,6.7,0,0,0,.24,2.43c.52,1.43,3.22,1,4.5.89l4.28-.19v-3.13Z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 263.23,
    y1: 208.61,
    x2: 263.23,
    y2: 201.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#272c2f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272c2f"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-30",
    x: 33.49,
    y: 70.42,
    width: 325.2,
    height: 50.16,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M358.24,120.5c.16-.09.59-.22.42-.43-.34-.43-1.5-.07-2,0,.16-.15,1.31-.75,1-1.11s-1.78.32-2,.39a27.91,27.91,0,0,1-3,1,25,25,0,0,0,5.58.19Zm-17.18-2c-.86-.63-1.68-1.3-2.41-1.78-7.62-5-15.3-10-22.71-15.39-7.09-5.12-14.43-9.91-21.8-14.59,1.34-1,2-.79.31-1.79a18,18,0,0,1,3.23-.91c-1.84-1-3.67-2-5.52-2.93-.94-.51-4.2-1.31-4.36-2.18h.14c-.32-1-2.62-1.46-3.64-1.77l-6-1.81a60.67,60.67,0,0,0-9.4-1.68c-.11.58-.69,0-.89,0a20.31,20.31,0,0,0-2.37-.38c-2.13-.25-4.25-.55-6.38-.69-5.07-.34-10.14-.7-15.22-.91L240,71.54c-.18,0-.24.07-.36.08s.13.19-.31.18a.76.76,0,0,1-.61-.31,38.2,38.2,0,0,0-5.77-.23c-4.94-.12-9.87-.29-14.81-.37l-8.78-.14-4-.07c-.71,0-.82.26-1.35.25s-.84-.28-1.55-.29l-3.73,0-9.57-.11c-9.54-.11-19.07-.07-28.6,0-18.33,0-36.67.4-55,.72l-17.26.35-11,.23-3.72.07a15.57,15.57,0,0,1-2.53.33v-.27c-3.48,0-7,.12-10.45.22l-7,.21c-.9,0-1.8.1-2.71.15s-1.34.35-2.06.41a13.9,13.9,0,0,0-1.38-.21c-.93,0-1.86.22-2.78.33-1.86.23-3.71.45-5.56.72-.62.09-2.29,0-2.74.44a8.56,8.56,0,0,0-.89,2.41C35.14,77.47,33,79,33.82,80c-1.39.45,2.08.13,2.07.16-.27.88,2.07,1.34,2.78,1.52,2,.51,5.23,2.32,5,4,1.1,4.25,1.78,5.35,2.75,11.67l.83,6.27c9,0,6,0,19.17.09.92,0,2.54.57,3.89-2.12a77.63,77.63,0,0,1,6.94-11.44c5.84-7.89,13.38-9.81,34.69-10.44S145,79.18,145,79.18l76.93.54A5.47,5.47,0,0,1,226,80.81l-.09-.26c.83.69,1.45,1.23,1.63,3.61s.42,11.14.55,20.64c0,2,.8,2.94,1.21,3l1.36.09c.82.05.66-5.36,1.49-5.31,1.11.07,3.2,5.61,4.31,5.68a7.75,7.75,0,0,0,7.16-5.18l-1-20.76.39,0v0s25.8-2,42.77,8.51,18.25,11.39,18.25,11.39l1.24,11.93c13.2,1.42,25.3,2.91,35.76,4.44ZM226.52,81.37l.07.09-.07-.09Zm.17.24.07.11-.07-.11Zm.16.27a.61.61,0,0,1,.07.14.61.61,0,0,0-.07-.14Zm.07.14a.61.61,0,0,1,.07.14.61.61,0,0,0-.07-.14Zm.08.15a1,1,0,0,0,.07.15,1,1,0,0,1-.07-.15Zm.07.16.06.15-.06-.15Zm.07.16a1,1,0,0,1,.05.16,1,1,0,0,0-.05-.16Zm.06.18a.75.75,0,0,1,.05.16.75.75,0,0,0-.05-.16Zm.05.17.06.18a1.89,1.89,0,0,0-.06-.18Zm-1-.71a5.84,5.84,0,0,0-3.47-.65L145.88,81s-11.76-.2-33.08.43S84,83.93,78.11,91.82a74,74,0,0,0-5.8,9.26c-1.65,3.09.84,2.57,1.61,2.57,21.14.11,45.35.34,68.26.76.61,0,.49-3.06,1.09-3s1.23,3.1,2.24,3.11c9.69.19,19.12.41,27.94.68,16.66.5,34,1.3,51.33,2.34.69,0,1.67-.88,1.93-2.71-.12-9.84-.3-20.77-.42-22.38s0-.18,0-.27Z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 196.1,
    y1: 106.91,
    x2: 196.1,
    y2: 72.59,
    xlinkHref: "#linear-gradient-21"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_119",
    x1: -737.56,
    y1: 499.5,
    x2: -540.57,
    y2: 499.5,
    gradientTransform: "translate(836.01 -311.15) scale(0.97)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#535f6e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#232630"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#424244"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-31",
    x: 64.52,
    y: 154.28,
    width: 96.64,
    height: 42.61,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M64.52,183.9s1.72-8.27,3.7-11.62,3-4.82,3-4.82l-2.07-1.89s10.85-10.33,26-11.19,25.13,4.13,30.12,8.78a46,46,0,0,1,6.17,7.86l-7.82-.19a28.3,28.3,0,0,0-8.84-5.78c-14.12-5.94-24.81-3.77-32,.19s-12,11.6-13.06,15-2,5.94-2,5.94l-3.27-2.32Zm70.67-6.73a50.37,50.37,0,0,1,4.63,10c1.29,5.07,3.44,8.34,8.09,9s13.25.77,13.25.77l-22-.09s-3.36.26-5.42-6.28c-1.07-3.39-2.33-8.53-5.27-13.52l6.75.17Z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 112.84,
    y1: 154.15,
    x2: 112.84,
    y2: 205.73,
    xlinkHref: "#linear-gradient-25"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-32",
    x: 315.14,
    y: 155.3,
    width: 77.86,
    height: 47.65,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M315.14,197.7a2.53,2.53,0,0,0,2.23-2.38c.36-2.3,1.73-21.35,12.51-30.77s20.06-9.56,29-9.13,22.07,7.19,26.31,13.73,6.48,16.68,6.83,19.7,1,13.37,1,13.37a5.24,5.24,0,0,1-2.87.72c-1.66-.07-1.59-1.65-1.59-2.87s.72-15-5.6-25.74-19.84-14-27-13.8-21.13,3.52-27.1,14.37-6.68,19.63-7.55,22.36-2.3,2.23-6.11.44Z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 354.07,
    y1: 154.15,
    x2: 354.07,
    y2: 202.35,
    xlinkHref: "#linear-gradient-25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_71",
    x1: -215.03,
    y1: 579.11,
    x2: -285.45,
    y2: 575.42,
    gradientTransform: "translate(355.49 -438.37)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#bcbcbb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#4e4e4e"
  })))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "27.49 197.37 134.98 205.46 320.45 206.84 378.64 205.43 399.83 203.73 371.58 158.25 86.53 160.23 27.49 197.37 27.49 197.37"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "wheels"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M354.86,169.12A26.92,26.92,0,1,1,328,196,26.92,26.92,0,0,1,354.86,169.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M354.87,169.12h.74L354.55,171c-.42,0-.83,0-1.24.05l1-1.87Zm1.44,0c.56,0,1.13.08,1.68.14L356.74,171c-.49,0-1-.06-1.49-.07l1.06-1.79Zm2.37.23c.57.08,1.12.18,1.66.29l-1.43,1.59c-.48-.07-1-.14-1.46-.19l1.23-1.69Zm2.35.44c.55.13,1.09.27,1.63.44l-1.6,1.45c-.47-.12-.95-.23-1.44-.32l1.41-1.57Zm2.29.65c.54.18,1.07.37,1.59.58l-1.62,1.34c-.51-.18-1-.35-1.53-.49l1.56-1.43Zm2.23.85c.52.22,1,.46,1.54.72l-1.76,1.18c-.45-.21-.91-.4-1.38-.59l1.6-1.31Zm2.15,1c.5.27,1,.56,1.46.86l-1.87,1c-.43-.25-.88-.48-1.32-.71l1.73-1.16Zm2,1.24c.47.31.93.64,1.38,1l-2,.83c-.41-.28-.82-.56-1.25-.81l1.84-1Zm1.93,1.41c.44.35.87.71,1.29,1.09l-2,.64c-.38-.32-.78-.63-1.18-.92l1.94-.81Zm1.8,1.57c.4.38.8.79,1.18,1.2l-2.11.44c-.35-.35-.72-.69-1.09-1l2-.63Zm1.64,1.72c.38.42.74.86,1.08,1.31l-2.07.33c-.35-.41-.7-.81-1.08-1.2l2.07-.44Zm1.49,1.86c.34.45.66.92,1,1.4l-2.1.13c-.29-.41-.59-.81-.9-1.21l2-.32Zm1.33,2c.29.48.57,1,.83,1.48l-2.12-.08c-.25-.43-.51-.85-.79-1.27l2.08-.13Zm1.14,2.1c.25.5.48,1,.69,1.54l-2.11-.28c-.21-.45-.43-.9-.67-1.33l2.09.07Zm.95,2.19c.2.52.39,1.05.55,1.59l-2.09-.49c-.17-.47-.35-.92-.54-1.38l2.08.28Zm.75,2.26c.15.54.29,1.08.41,1.63l-2.05-.7c-.13-.47-.26-.95-.42-1.41l2.06.48Zm.55,2.33c.1.55.18,1.11.25,1.67l-1.95-.79c-.09-.53-.19-1.06-.31-1.57l2,.69Zm.33,2.35c.06.56.09,1.13.11,1.7l-1.88-1c0-.5-.09-1-.16-1.48l1.93.77Zm.13,2.39V196c0,.48,0,1,0,1.43L380,196.28V196c0-.41,0-.82,0-1.23l1.85,1Zm-.08,2.39c-.05.56-.11,1.11-.19,1.67l-1.67-1.37c0-.49.08-1,.09-1.47l1.77,1.17Zm-.3,2.36c-.09.56-.2,1.12-.33,1.66l-1.57-1.41c.1-.53.19-1.06.26-1.59l1.64,1.34Zm-.49,2.33c-.15.55-.31,1.09-.49,1.63L379,202.92c.13-.48.25-1,.36-1.45l1.55,1.39Zm-.71,2.28c-.19.54-.4,1.06-.62,1.58L378.3,205c.18-.46.34-.93.49-1.4l1.41,1.54Zm-.91,2.22c-.24.51-.49,1-.76,1.5l-1.1-1.84c.21-.44.42-.9.61-1.35l1.25,1.69Zm-1.1,2.11c-.28.49-.58,1-.89,1.43l-.93-1.94c.26-.43.5-.86.73-1.3l1.09,1.81Zm-1.29,2c-.32.46-.66.92-1,1.36l-.81-2c.32-.43.62-.87.91-1.32l.91,1.91Zm-1.44,1.89c-.37.43-.75.85-1.14,1.27l-.63-2c.33-.38.66-.77,1-1.16l.81,1.91Zm-1.62,1.76c-.41.39-.82.78-1.24,1.15l-.44-2.07c.36-.35.72-.7,1.06-1.07l.62,2Zm-1.77,1.6c-.44.36-.88.71-1.34,1.05l-.23-2.12c.39-.32.77-.64,1.14-1l.43,2Zm-1.9,1.45c-.47.32-.94.63-1.42.91l0-2.14c.41-.27.82-.56,1.22-.86l.23,2.09Zm-2,1.27q-.73.42-1.5.78l.18-2.14q.66-.36,1.29-.75l0,2.11ZM366,220.54c-.51.23-1,.44-1.56.65l.28-2.08c.49-.22,1-.44,1.46-.68l-.18,2.11Zm-2.21.88c-.53.19-1.07.37-1.62.52l.49-2.06q.72-.23,1.41-.51l-.28,2Zm-2.28.7c-.55.14-1.1.26-1.66.36l.69-2c.49-.11,1-.24,1.45-.38l-.48,2Zm-2.34.48c-.56.09-1.12.17-1.68.22l.9-1.95c.49-.06,1-.15,1.46-.24l-.68,2Zm-2.37.28c-.56,0-1.12.06-1.69.07l1.1-1.86c.5,0,1-.07,1.47-.13l-.88,1.92Zm-2.39.06c-.57,0-1.13,0-1.69-.07l1.17-1.77c.32,0,.63,0,1,0h.64l-1.08,1.82Zm-2.38-.14c-.56-.06-1.12-.13-1.68-.23l1.35-1.64c.49.06,1,.11,1.48.14l-1.15,1.73Zm-2.36-.35c-.56-.11-1.11-.23-1.65-.37l1.52-1.52c.48.1,1,.19,1.45.27l-1.32,1.62Zm-2.33-.56c-.53-.16-1.07-.33-1.59-.52l1.66-1.36c.48.14.95.27,1.43.39l-1.5,1.49Zm-2.25-.77c-.53-.2-1.05-.42-1.55-.66l1.69-1.25c.49.21,1,.39,1.5.57l-1.64,1.34Zm-2.18-1c-.5-.26-1-.53-1.49-.81l1.81-1.09q.66.36,1.35.66l-1.67,1.24ZM340.84,219c-.48-.3-1-.61-1.42-.93l1.92-.91c.42.27.85.52,1.29.77L340.84,219Zm-2-1.34c-.45-.33-.89-.69-1.32-1l2-.72c.39.3.8.59,1.21.87l-1.89.9Zm-1.86-1.5c-.41-.38-.82-.76-1.22-1.16l2.07-.54c.37.34.74.66,1.13,1l-2,.72Zm-1.71-1.67c-.38-.41-.76-.82-1.11-1.26l2.12-.33c.33.37.68.72,1,1.07l-2,.52Zm-1.56-1.8c-.34-.44-.68-.89-1-1.35l2.16-.13c.3.39.61.77.93,1.15l-2.09.33Zm-1.39-1.94c-.31-.47-.6-.95-.88-1.44l2.11,0c.28.46.58.91.89,1.34l-2.12.13Zm-1.22-2c-.26-.5-.52-1-.75-1.52l2.11.17q.34.67.72,1.32l-2.08,0Zm-1-2.16c-.22-.52-.43-1.05-.61-1.58l2.09.39c.19.46.39.92.6,1.36l-2.08-.17Zm-.84-2.24c-.17-.53-.33-1.07-.46-1.62l2.06.6c.14.47.3.94.47,1.4l-2.07-.38Zm-.63-2.3c-.12-.54-.23-1.09-.32-1.65l2,.8c.1.49.22,1,.34,1.44l-2-.59Zm-.42-2.35q-.12-.84-.18-1.68l1.92.89c.06.53.14,1.06.23,1.59l-2-.8ZM328,197.3q0-.63,0-1.26c0-.15,0-.29,0-.43l1.83,1.08c0,.5,0,1,.08,1.49L328,197.3Zm0-2.39q0-.85.12-1.68l1.73,1.27c0,.49-.05,1-.05,1.48l-1.8-1.07Zm.2-2.38c.07-.56.16-1.11.27-1.66l1.6,1.46c-.07.48-.13,1-.17,1.46l-1.7-1.26Zm.42-2.35c.12-.55.25-1.1.41-1.64l1.49,1.5c-.12.52-.24,1-.33,1.57l-1.57-1.43Zm.61-2.3c.17-.54.36-1.07.56-1.6l1.35,1.65c-.16.47-.31.94-.44,1.42l-1.47-1.47Zm.83-2.24c.21-.52.45-1,.7-1.54l1.18,1.78c-.2.45-.39.91-.56,1.38L330,185.64Zm1-2.16c.26-.5.54-1,.83-1.47l1,1.9c-.24.43-.46.87-.68,1.32l-1.16-1.75Zm1.21-2.06c.3-.47.62-.93,1-1.38l.83,2c-.27.41-.54.83-.79,1.25l-1-1.86Zm1.38-1.94c.35-.45.7-.87,1.07-1.29l.65,2.07q-.48.57-.9,1.17l-.82-2Zm1.55-1.82c.38-.41.78-.81,1.19-1.19l.53,2c-.38.39-.74.78-1.09,1.19l-.63-2Zm1.7-1.66c.42-.38.86-.74,1.3-1.1l.33,2.1c-.38.33-.75.66-1.11,1l-.52-2Zm1.85-1.52c.45-.33.91-.66,1.38-1l.13,2.13c-.4.29-.8.59-1.19.9l-.32-2.06Zm2-1.34c.48-.3,1-.58,1.46-.85l-.08,2.14c-.43.26-.84.52-1.25.8l-.13-2.09ZM342.8,172c.5-.25,1-.49,1.53-.71l-.28,2.14c-.45.21-.89.44-1.32.68l.07-2.11Zm2.18-1c.52-.21,1-.4,1.58-.57l-.5,2.11c-.46.17-.91.36-1.36.56L345,171Zm2.26-.78c.54-.16,1.09-.31,1.64-.43l-.59,2c-.53.14-1,.3-1.54.47l.49-2.07Zm2.31-.57c.55-.11,1.11-.21,1.67-.28l-.8,2c-.49.09-1,.19-1.45.31l.58-2Zm2.37-.37c.55-.06,1.11-.1,1.68-.13l-1,1.9-1.46.17.79-1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M354.86,171a25,25,0,1,1-25,25A25,25,0,0,1,354.86,171Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M354.87,171.81A24.23,24.23,0,1,1,330.64,196a24.23,24.23,0,0,1,24.23-24.23Zm0,.58A23.65,23.65,0,1,1,331.22,196a23.65,23.65,0,0,1,23.65-23.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M354.86,173.17A22.87,22.87,0,1,1,332,196,22.88,22.88,0,0,1,354.86,173.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M356.2,178.46a18.91,18.91,0,1,1-18.91,18.92A18.91,18.91,0,0,1,356.2,178.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M354.86,181.59A14.45,14.45,0,1,1,340.42,196,14.45,14.45,0,0,1,354.86,181.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M354.86,184.86A11.18,11.18,0,1,1,343.69,196,11.18,11.18,0,0,1,354.86,184.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M367.25,195.59a6.31,6.31,0,0,0-.06-2c-.21-.58-.49-.58-1-.39a8.57,8.57,0,0,1-1.53.32l-.08,1.94,2.63.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M367.29,195.13l-2.17-.4-.66.46q-.4,6.62-6.9,10.39l-.13,1.75L359,208c5.57-2,8.72-6,8.33-12.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M367.29,195.13l-.6-.11c-.29,6.56-3.22,10.7-8.54,12.64l.81.38c5.57-2,8.72-6,8.33-12.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M369.1,189.21l.09.29-.11-.28h0l-.16,0-.55.46.07.16.72-.07.12-.09,2.22,0,.88.19.77.23h0l-5-.05-.21-.11,0-.23,3.51-3.46L371,187l-.47.68-1.49,1.5h0l0,0Zm1.33,8.8.06-.06-.06.06Zm-8.74,12.25-.29.1.16-.07.14-.06,0-.15-.46-.55-.17.06.07.73.1.12,0,2.22-.18.88-.23.77h0l0-5,.11-.2h.24l3.45,3.51-.7-.4-.68-.48-1.51-1.49Zm7.16-9-.06.16.59.5h.13v0l.17-.5-.05-.07-.78-.06Zm.78.77,1.33,1.54.44.63.49.79-3.49-3.63,0-.24.2-.12,4.83.26-.81.16-.75.06-1.87-.06-.15.15-.12.25-.06.11v.1Zm-20,8.79,0-.43,0-.34-.16-.06-.49.58v.13h0l.49.18h0l.07,0Zm-9-7.93-.1-.29v0l.07.17.07.15h.15l.56-.47-.07-.16-.72.07-.13.1-2.21,0-.88-.19-.77-.22h0l5,0,.2.11v.23l-3.5,3.46.39-.71.48-.68,1.49-1.5,0,0Zm6.72,9.27-.63.44-.79.49,3.62-3.49.25,0,.13.19-.26,4.84-.17-.82-.05-.74.05-1.87-.14-.15-.26-.12-.11,0h-.1l-1.54,1.33Zm-7.26-21.35.79.06.06-.16-.59-.5h-.12l0,0-.17.5.05.07Zm-2.19-.16,1.88.06.14-.15.13-.25.05-.11v-.1l-1.33-1.55-.44-.62-.49-.79,3.48,3.63.06.24-.2.13-4.83-.27.81-.16.74-.06Zm10.12-8.8h0l.3-.11-.12.05-.19.09,0,.15.46.56.16-.07-.06-.73-.1-.12,0-2.22.19-.88.23-.77h0l0,5-.11.2-.24,0-3.45-3.5.71.39.67.48,1.51,1.49Zm12.69-.44-.51-.18h0l0,0-.05.05h0l0,.43,0,.34.17.07.48-.59v-.15Zm-.44-2.29-.06,1.86.15.15.25.12.11.06h.1l1.55-1.33.63-.43.79-.51-3.63,3.5-.24.05-.14-.19.27-4.84.16.81.06.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M354.05,190.79l.37-.76.77-.53.83-.24,1-2,.85-1.82.62-1.69.37-1.7.23-4-.2-.55-.76-.43,2,.44-.26,4.84.13.19.24-.05,3.63-3.5,1.73,1-.94-.14-.63.29L361.05,183l-1.21,1.48-1,1.46-1,1.73-.9,1.92.06.07.55.61.29.8.46.65.47.14,1.64-.28,3.2-.92,1.91-.65,1.72-1,3-2.9.25-.47,0-.62.91,1.36-3.51,3.45,0,.23.21.11,5,.05h0l.33,1.13.19,1-.39-.67-.74-.4-4.39,0-2.24.26-2.05.37-3.39.67-1.64.34-.08,0h0l-1.26.36-.84.19-1.09.12h0l-.75-.24-.69-.66-.34-.87.05-.51.19-.09,0-.32ZM351,199.25h0l1.26-.36.84-.19,1.08-.11h0l.75.24.69.66.35.88,0,.51-.19.08,0,.32-.38.76-.76.53-.82.24-1,2-.85,1.82-.63,1.69-.36,1.71-.24,4,.2.55.77.43-2-.44.26-4.84-.13-.19-.25,0-3.62,3.49-1.73-1,.94.14.63-.28,2.91-2.8,1.21-1.47,1-1.46,1-1.73.9-1.92-.06-.07-.55-.61-.3-.81-.46-.64-.46-.15-1.65.28-3.19.92-1.92.65-1.71,1-3,2.9-.25.47,0,.63-.89-1.36,3.5-3.46v-.23l-.2-.11-5,0h0l-.33-1.14-.2-1,.4.65.73.42,4.39,0,2.26-.25,2-.38,3.39-.66,1.65-.35.08,0Zm4.39,1.86.07-.63-.26-.68-.54-.5-.7-.22-.68.11-.64.42-.33.62v.06l0,.67.25.69.48.56.71.23.75-.16.6-.42.34-.66v-.09Zm-3.14-5-.81.65-.88.33-.5,0-.07-.19-.34,0-.75-.38-.54-.76-.23-.83-2-1-1.82-.85-1.68-.62-1.71-.36-4-.24-.55.19-.42.78.44-2,4.83.27.2-.13-.06-.24-3.48-3.63h0l1-1.73-.14.94.27.64,2.8,2.92,1.48,1.19,1.46,1,1.72,1,1.94.9.67-.61.81-.3.64-.46.14-.47-.27-1.64-.93-3.19-.64-1.93-1.05-1.71-2.9-3-.47-.24-.63,0,1.37-.91,3.45,3.5.24,0,.11-.2,0-5h0v0l1.13-.33,1-.19-.67.39-.42.74,0,4.4.26,2.25.37,2,.67,3.38.34,1.64,0,.09h0l.36,1.27.2.84.11,1.08h0l-.09.81Zm5.2.6.1-.81.81-.65.87-.33.5.05.09.18.33,0,.75.38.54.76.23.83,2,1,1.82.85,1.69.62,1.71.36,4,.24.55-.19.43-.78-.45,2-4.83-.26-.2.12,0,.24,3.49,3.63-1,1.74.14-.94-.28-.63-2.8-2.92-1.47-1.2L365,200l-1.73-1-1.92-.91-.69.61-.8.3-.65.47-.14.46.28,1.64.93,3.19.64,1.93,1,1.71,2.9,3,.47.24.63,0-1.36.91-3.45-3.51h-.24l-.11.2,0,5h0v0l-1.1.31h0l-.25.06-.73.15.67-.4.42-.73v-4.41l-.26-2.24-.37-2-.67-3.39-.33-1.64,0-.09h0l-.35-1.27-.2-.84-.11-1.08Zm2.52-1.21-.63-.05-.68.26-.49.53-.23.71.11.67.42.65.62.32h.07l.66.05.7-.25.55-.49.23-.7-.16-.75-.41-.62-.67-.33Zm-2.48-3.75.05-.67-.25-.68-.49-.57-.7-.22-.75.15-.61.42-.33.67V191l-.07.63.26.68.54.49.7.23.67-.11.65-.42.33-.62v-.06Zm-7.66,4.76.62.05.69-.25.49-.54.22-.71-.11-.67-.41-.65-.63-.33h-.05l-.68-.05-.68.25-.56.49-.24.71.17.74.41.61.66.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M357.65,215.07l-2,.18-2,0-2-.23-.77-.42-.2-.56.24-4,.36-1.71.63-1.69.85-1.82,1-2,.82-.24.76-.53.38-.76,0-.32.19-.08,0-.51-.35-.88-.63-.81.8-.16.73-.41.56-.61.35-.75.11,1.08.2.84.35,1.27,0,.08.33,1.64.67,3.39.37,2,.26,2.25v4.4l-.42.73-.67.4-1,.2Zm-16.74-8,1.23,1.4,1.38,1.27,1.22.91.49-.05,1.73-2.15,3.53-6.52.09-.49-.26-.45-.5-.18-.42.07-6.47,3.7-2.21,1.65-.07.48.26.36Zm-1.49-1h0l3-2.9,1.71-1,1.92-.65,3.19-.92,1.65-.28.46.15.46.64.3.81.55.61.06.07-.9,1.92-1,1.73-1,1.46-1.21,1.47-2.91,2.8-.63.28-.94-.14-1.62-1.2-1.47-1.37L339.79,208l-.6-.83,0-.63.25-.47ZM336,199.82h0l-.19-1-.19-2h0l0-2h0l.24-2,.42-.78.55-.19,4,.24,1.71.36,1.68.62,1.82.85,2,1,.23.83.54.76.75.38.33,0,.08.19.5,0,.88-.33.81-.65.16.82.41.71.61.57.75.35-1.08.11-.84.19-1.26.36-.08,0-1.64.35-3.4.66-2,.38-2.26.25-4.39,0-.73-.42-.4-.65Zm1-3.06.17,1.86.19.95.4.27,2.68-.59,7.08-2.17.47-.31.24-.47-.26-.45-.46-.33-7.34-2-2.6-.5-.37.27-.18,1.57,0,1.86Zm3.18-10.86,0,.5,2.14,1.73,6.53,3.53.48.08.46-.26.18-.49-.07-.42-3.7-6.48-1.66-2.2-.48-.07-.36.25-1.4,1.24-1.26,1.36-.9,1.23Zm1.53,4h0L339,187l-.27-.64.14-.94,1.2-1.61,1.36-1.48L343,181l.82-.58.63,0,.47.24,2.9,3,1.05,1.71.64,1.93.93,3.19.27,1.64-.14.47-.64.46-.81.3-.67.61-1.94-.9-1.72-1-1.46-1-1.48-1.19Zm12.62.16-.37.76,0,.32-.19.09-.05.51.34.87.64.81-.81.16-.72.41-.56.61-.35.75-.11-1.08-.2-.84-.36-1.27,0-.08-.34-1.64-.67-3.38-.37-2-.26-2.25,0-4.4.42-.74.67-.39,1-.2,2-.19,2,0,2,.23.76.43.2.55-.23,4-.37,1.7-.62,1.69-.85,1.82-1,2-.83.24-.77.53Zm.18-.54.45-.27.33-.46,2-7.34.51-2.59-.27-.37-1.57-.19h-1.86l-1.86.17-1,.19-.27.39.58,2.69,2.18,7.07.3.47.47.25Zm4.82,1.6.5.18.42-.08,6.47-3.69,2.21-1.66.06-.48-.25-.36-1.23-1.4-1.38-1.26-1.22-.91-.49,0-1.73,2.14-3.53,6.54-.09.47.26.47Zm-1.54-.05h0l-.29-.81-.55-.6-.06-.07.9-1.92,1-1.73,1-1.46,1.21-1.48,2.91-2.79.63-.29.94.14,1.61,1.21,1.48,1.36,1.33,1.51.59.84,0,.62-.25.47-3,2.9-1.72,1-1.91.65-3.2.92-1.64.28-.47-.14-.46-.65Zm2.24,4.17-.33,0-.09-.18-.5-.05-.87.33-.81.65-.17-.82-.4-.72-.61-.56-.76-.34,1.09-.12.84-.19,1.26-.36.08,0,1.64-.34,3.39-.67,2.05-.37,2.24-.26,4.39,0,.74.4.39.67.2,1,.19,2,0,2-.23,2-.43.78-.55.19-4-.24-1.71-.36-1.69-.62-1.82-.85-2-1-.23-.83-.54-.76-.75-.38Zm1.3.56.26.45.46.33,7.34,2,2.6.5.36-.27.19-1.57,0-1.86-.18-1.85-.19-1-.39-.26-2.68.58L362.13,195l-.47.3-.24.47Zm-1.79,5.32.08.41,3.7,6.48,1.65,2.2.48.07h0l.37-.26,1.39-1.23,1.27-1.36.9-1.23,0-.49-2.14-1.74-6.53-3.53-.48-.08-.46.26-.19.5Zm-.56-1.11h0l.14-.46.65-.47.8-.3.69-.61,1.92.91,1.73,1,1.46,1,1.47,1.2,2.8,2.92.28.63-.14.94-1.2,1.61-1.36,1.48-1.51,1.33-.84.59-.63,0-.47-.24-2.9-3-1-1.71-.64-1.93-.93-3.19-.28-1.64Zm-3.48,13.84,1.86-.17.95-.2.27-.39-.58-2.69-2.19-7.08-.29-.46-.48-.25-.44.27-.34.45-2,7.35-.51,2.6.27.36,1.57.19,1.86,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-48",
    points: "354.05 175.97 355.41 175.98 356.89 176.07 358.24 176.23 359.66 176.55 360.88 176.9 362.29 177.37 363.58 177.97 364.78 178.59 366.01 179.31 367.13 180.15 368.18 181.02 369.24 182 370.17 183.05 371.01 184.11 371.85 185.29 372.55 186.55 373.12 187.69 373.7 189.05 374.14 190.46 374.47 191.74 374.75 193.12 374.88 194.53 374.91 195.22 374.08 195.25 373.89 193.25 373.69 192.26 373.5 191.28 373.17 190.15 373.15 190.14 373.14 190.14 373.14 190.15 373.14 190.14 372.37 189.91 371.49 189.72 369.27 189.69 369.23 189.59 369.21 189.54 369.19 189.5 369.1 189.21 369.08 189.19 369.08 189.19 370.57 187.69 371.04 187.01 371.45 186.31 370.54 184.95 369.95 184.11 368.62 182.6 367.14 181.24 365.53 180.03 363.8 179 363.01 179.51 362.38 179.94 360.83 181.27 360.73 181.28 360.62 181.22 360.37 181.1 360.23 180.95 360.28 179.09 360.23 178.33 360.06 177.52 358.1 177.08 356.1 176.85 354.09 176.82 352.08 177.01 351.1 177.21 350.11 177.4 348.98 177.73 348.98 177.75 348.98 177.76 348.97 177.76 348.74 178.53 348.56 179.41 348.52 181.63 348.42 181.67 348.36 181.7 348.35 181.7 348.05 181.81 348.03 181.82 346.52 180.34 345.85 179.85 345.14 179.46 343.77 180.37 342.95 180.95 341.43 182.28 340.07 183.76 338.87 185.37 337.84 187.1 337.84 187.11 337.85 187.11 338.34 187.9 338.78 188.52 340.11 190.07 340.11 190.17 340.06 190.28 339.93 190.53 339.79 190.68 337.91 190.62 337.17 190.68 336.36 190.84 335.92 192.81 335.68 194.8 335.68 194.81 335.66 196.81 334.83 196.85 334.8 196.11 334.82 194.75 334.98 193.42 335.22 191.97 335.52 190.61 335.97 189.31 336.5 187.96 337.08 186.71 337.81 185.47 338.53 184.39 339.41 183.21 340.32 182.21 341.38 181.19 342.42 180.28 343.56 179.46 344.72 178.72 344.73 178.72 345.96 178.03 347.21 177.5 348.57 176.99 349.9 176.58 351.26 176.3 352.66 176.1 354.05 175.97 354.05 175.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "355.65 215.25 357.65 215.06 358.64 214.87 359.37 214.72 359.63 214.66 359.66 214.65 360.76 214.34 360.76 214.32 360.76 214.31 360.77 214.31 361 213.54 361.18 212.66 361.22 210.44 361.31 210.4 361.37 210.38 361.4 210.36 361.69 210.26 361.71 210.25 363.22 211.74 363.9 212.22 364.6 212.62 365.96 211.71 366.8 211.12 368.31 209.79 369.67 208.31 370.87 206.7 371.89 204.96 371.4 204.17 370.96 203.54 369.63 202 369.63 201.9 369.68 201.79 369.8 201.54 369.95 201.39 371.82 201.45 372.57 201.39 373.38 201.23 373.83 199.26 374.06 197.26 374.08 195.25 374.91 195.22 374.93 195.86 374.92 197.32 374.75 198.78 374.53 200.05 374.21 201.46 373.73 202.87 373.3 203.97 372.66 205.36 371.89 206.66 371.24 207.63 370.33 208.86 369.31 209.96 368.48 210.78 367.32 211.79 366.07 212.68 365.12 213.28 363.78 214.04 362.39 214.64 361.31 215.04 359.84 215.5 358.34 215.8 357.22 215.96 355.68 216.11 354.15 216.09 353.02 216.02 351.49 215.83 350.05 215.51 348.85 215.18 347.45 214.7 346.15 214.1 344.98 213.5 343.73 212.75 342.58 211.89 341.56 211.05 340.5 210.07 339.6 209.05 338.68 207.89 337.89 206.78 337.31 205.75 337.25 205.64 336.58 204.28 336.03 203.01 335.62 201.69 335.26 200.29 334.99 198.94 334.87 197.61 334.83 196.85 335.66 196.81 335.66 196.82 335.85 198.82 336.04 199.81 336.04 199.82 336.24 200.79 336.57 201.93 336.59 201.93 336.59 201.93 336.6 201.94 336.6 201.94 337.37 202.16 338.25 202.35 340.46 202.39 340.51 202.49 340.53 202.54 340.54 202.57 340.64 202.86 340.66 202.88 339.17 204.38 338.69 205.06 338.3 205.77 339.19 207.13 339.79 207.96 341.12 209.47 342.6 210.84 344.21 212.04 345.94 213.06 346.73 212.56 347.36 212.13 348.9 210.8 349 210.8 349.11 210.85 349.37 210.96 349.51 211.12 349.46 212.99 349.51 213.73 349.68 214.55 351.64 214.99 353.64 215.22 355.65 215.25 355.65 215.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M342.1,187.32l.5.44,6.52,3.59.33.06.26-.12.09-.29-.07-.35-3.83-6.43-.42-.47-.39-.08-1.24,1.09L342.74,186l-.74,1h0l.11.36Zm9.79,25.93.51-2.6,2-7.35.34-.45.44-.27.48.25.29.46,2.19,7.08.58,2.69-.27.39-.58-1.3-.26-.6.28-.27-.12-.68-2-7.19-.22-.37-.33-.16-.3.16-.26.34-1.84,7.4-.06.59.27.29h0l0,.06-.22.54-.55,1.33-.27-.36Zm9.53-17.48.24-.47.47-.3,7.08-2.18,2.68-.58.39.26.2,1,.17,1.85-2,.09-.16-1.65-.08-.4-.27-.29-.67.14-7.2,2-.36.23-.16.32-.3,0Zm-24.13-2.44.37-.27,2.6.5,7.34,2,.46.33.26.45H348l-.16-.29-.34-.27-7.39-1.84-.59-.06-.3.27h0l-.09.9,0,1.64-2,.09,0-1.86.18-1.57Zm14.36-11.63-.58-2.69.27-.39,1-.19,1.86-.17H356l1.57.19.27.37-.51,2.59-2,7.34-.33.46-.45.27-.47-.25-.3-.47-2.18-7.07Zm.53-1.18-.29.27.13.68,2,7.2.22.36.33.16.3-.16.26-.34,1.84-7.4.06-.59-.27-.29h0l-.89-.09-1.65,0-1.65.16-.4.08Zm7.07,9.63,3.53-6.54,1.73-2.14.49,0,1.22.91,1.38,1.26,1.23,1.4.25.36-.06.48-2.21,1.66-6.47,3.69-.42.08-.5-.18-.26-.47.09-.47Zm3.9-6.39h0l-3.6,6.53-.06.33.12.27.3.08.35-.08,6.43-3.83.47-.41.07-.39L366.14,185l-1.21-1.12-1-.74-.35.11-.44.49Zm-20.7,4.37h0l-2.14-1.73,0-.5.9-1.23,1.26-1.36,1.4-1.24.36-.25.48.07,1.66,2.2,3.7,6.48.07.42-.18.49-.46.26-.48-.08-6.53-3.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M337.26,198.62l-.17-1.86,2-.09.15,1.65.08.4.28.3.68-.14,7.18-2,.37-.23.16-.33h.3l-.24.47-.47.31-7.08,2.17-2.68.59-.4-.27-.19-.95Zm16.47,15.18-1.57-.19.55-1.33.22-.54,0-.06.89.08,1.65,0,1.65-.15.4-.09.26.6.58,1.3-.95.2-1.86.17-1.86,0Zm16.87-16.75h0l0-1.65,2-.09,0,1.86-.19,1.57-.36.27-2.6-.5-7.34-2-.46-.33-.26-.45.3,0,.16.31.34.26,7.39,1.84.6.06.22-.21.06-.06h0l.1-.88Zm-10,3.67-.34-.06-.26.11-.08.3.07.35,3.83,6.43.42.47.39.08,1.24-1.09L367,206.1l.75-1-.11-.35-.5-.44-6.52-3.6Zm-.91.78h0l-.08-.41.18-.5.47-.26.48.08,6.53,3.53,2.14,1.74,0,.49-.9,1.23-1.27,1.36L365.91,210l-.37.27h0l-.48-.07-1.65-2.2-3.7-6.48ZM343.05,205l-.46.41-.09.39,1.1,1.24,1.21,1.12,1,.74.35-.11.44-.49,3.6-6.53.05-.33-.11-.26-.3-.09-.35.08L343.05,205Zm-.91,3.46h0l-1.23-1.4-.26-.36.07-.47,2.21-1.66,6.47-3.7.41-.07.51.17.26.46-.09.49L347,208.45l-1.73,2.15-.49.05-1.22-.91-1.38-1.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M357.09,194.55a2.63,2.63,0,1,1-3.59-1A2.62,2.62,0,0,1,357.09,194.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M357.49,190.43a1.83,1.83,0,1,1-2.5-.67A1.83,1.83,0,0,1,357.49,190.43Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "355.9 190.06 356.45 190.38 357 190.69 357 191.33 357 191.97 356.45 192.29 355.9 192.6 355.35 192.29 354.8 191.97 354.8 191.33 354.8 190.69 355.35 190.38 355.9 190.06 355.9 190.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M361.14,196.17a1.83,1.83,0,1,1-2.5-.67A1.83,1.83,0,0,1,361.14,196.17Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "359.54 195.81 360.1 196.12 360.65 196.44 360.65 197.08 360.65 197.71 360.1 198.03 359.54 198.35 358.99 198.03 358.44 197.71 358.44 197.08 358.44 196.44 358.99 196.12 359.54 195.81 359.54 195.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M355.49,199.92a1.83,1.83,0,0,1-3.17,1.82,1.83,1.83,0,1,1,3.17-1.82Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "353.9 199.55 354.45 199.87 355 200.19 355 200.82 355 201.46 354.45 201.77 353.9 202.09 353.35 201.77 352.8 201.46 352.8 200.82 352.8 200.19 353.35 199.87 353.9 199.55 353.9 199.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M351.77,194.12a1.83,1.83,0,1,1-2.5-.67A1.82,1.82,0,0,1,351.77,194.12Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "350.18 193.75 350.73 194.07 351.28 194.39 351.28 195.03 351.28 195.66 350.73 195.98 350.18 196.3 349.63 195.98 349.08 195.66 349.08 195.03 349.08 194.39 349.63 194.07 350.18 193.75 350.18 193.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M98.38,169a26.92,26.92,0,1,1-26.92,26.92A26.91,26.91,0,0,1,98.38,169Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M98.38,169h.75l-1.07,1.82c-.41,0-.83,0-1.24,0l1-1.86Zm1.44,0c.57,0,1.13.07,1.68.14l-1.25,1.72c-.49,0-1-.06-1.48-.07l1-1.79Zm2.37.23c.56.08,1.12.18,1.67.29l-1.44,1.59c-.48-.08-1-.14-1.46-.19l1.23-1.69Zm2.35.44c.55.13,1.09.27,1.62.43l-1.59,1.46c-.47-.13-1-.23-1.44-.32l1.41-1.57Zm2.3.65c.53.18,1.06.37,1.59.58l-1.63,1.34c-.5-.18-1-.35-1.53-.5l1.57-1.42Zm2.22.85c.52.22,1,.46,1.54.72l-1.76,1.18c-.45-.21-.91-.41-1.38-.59l1.6-1.31Zm2.15,1c.5.27,1,.56,1.46.86l-1.87,1c-.43-.25-.87-.48-1.32-.7l1.73-1.16Zm2.05,1.23c.47.32.92.64,1.38,1l-2,.83c-.4-.28-.82-.56-1.25-.82l1.85-1Zm1.92,1.41c.44.35.87.72,1.29,1.1l-2,.64c-.39-.32-.77-.63-1.17-.92l1.93-.82Zm1.8,1.57c.41.39.8.79,1.18,1.2l-2.11.45c-.35-.35-.71-.69-1.09-1l2-.63Zm1.65,1.73c.37.42.73.86,1.07,1.3l-2.07.34c-.35-.41-.7-.82-1.08-1.21l2.08-.43Zm1.49,1.86c.33.45.65.92,1,1.4l-2.11.13c-.29-.41-.59-.81-.9-1.21l2.05-.32Zm1.32,2c.29.49.57,1,.83,1.48l-2.12-.07c-.25-.43-.51-.86-.79-1.27l2.08-.14Zm1.14,2.1c.25.51.48,1,.69,1.55l-2.11-.28c-.21-.46-.43-.9-.66-1.34l2.08.07Zm1,2.19c.2.53.39,1.06.55,1.6l-2.09-.49c-.16-.47-.35-.92-.54-1.38l2.08.27Zm.75,2.27c.15.54.29,1.08.41,1.63l-2-.7q-.18-.72-.42-1.41l2.06.48Zm.55,2.32c.1.56.19,1.11.26,1.68l-2-.79c-.09-.53-.19-1.06-.31-1.58l2,.69Zm.33,2.36c.06.56.1,1.13.11,1.69l-1.88-1c0-.5-.09-1-.16-1.48l1.93.77Zm.13,2.39v.25q0,.72,0,1.44l-1.79-1.19v-.25c0-.41,0-.82,0-1.22l1.85,1Zm-.08,2.39c0,.56-.11,1.11-.18,1.66l-1.68-1.36c.05-.49.08-1,.1-1.47l1.76,1.17Zm-.29,2.36c-.1.56-.21,1.12-.34,1.66L123,200.62c.1-.53.18-1.06.25-1.59l1.65,1.34Zm-.5,2.33c-.15.55-.31,1.09-.48,1.63l-1.43-1.58c.14-.47.26-.95.37-1.44l1.54,1.39Zm-.71,2.28c-.19.53-.4,1.06-.62,1.57l-1.28-1.71c.18-.46.35-.93.5-1.4l1.4,1.54Zm-.91,2.21c-.24.51-.49,1-.76,1.51l-1.1-1.84c.21-.45.42-.9.61-1.36l1.25,1.69Zm-1.1,2.12c-.28.49-.57,1-.88,1.43l-.93-2q.38-.63.72-1.29l1.09,1.81Zm-1.28,2q-.49.69-1,1.35l-.81-1.94c.32-.43.62-.87.92-1.32l.91,1.91ZM119,213.2c-.37.44-.75.86-1.14,1.27l-.63-2c.34-.37.66-.76,1-1.16l.81,1.91ZM117.35,215c-.4.4-.82.79-1.24,1.16l-.44-2.08c.37-.34.72-.7,1.06-1.06l.62,2Zm-1.77,1.61c-.43.36-.88.71-1.33,1l-.24-2.12q.58-.47,1.14-1l.43,2Zm-1.9,1.45c-.46.31-.94.62-1.42.91l0-2.14c.42-.27.82-.56,1.22-.86l.23,2.09Zm-2,1.27c-.49.28-1,.54-1.49.78l.17-2.14q.66-.36,1.29-.75l0,2.11Zm-2.13,1.08c-.51.24-1,.45-1.56.66l.28-2.09c.49-.21,1-.44,1.46-.68l-.18,2.11Zm-2.2.89c-.54.19-1.08.36-1.62.52l.48-2.06q.72-.24,1.41-.51l-.27,2ZM105,222c-.55.14-1.1.26-1.66.36l.7-2c.48-.11,1-.24,1.44-.38l-.48,2Zm-2.34.48c-.55.09-1.11.16-1.68.22l.9-1.95c.49-.07,1-.15,1.46-.25l-.68,2Zm-2.37.28q-.84.06-1.68.06l1.1-1.86c.49,0,1-.06,1.46-.12l-.88,1.92Zm-2.39.06c-.57,0-1.13,0-1.69-.07l1.17-1.77,1,0H99l-1.08,1.83Zm-2.37-.14c-.57-.06-1.13-.13-1.68-.23l1.34-1.64c.49.06,1,.1,1.49.14l-1.15,1.73Zm-2.37-.35c-.56-.11-1.1-.23-1.64-.38l1.51-1.51c.48.1,1,.19,1.46.27l-1.33,1.62Zm-2.32-.56c-.54-.16-1.07-.33-1.6-.52L91,219.84c.47.15.94.28,1.42.39l-1.49,1.5ZM88.62,221c-.52-.2-1-.42-1.55-.66l1.69-1.25q.73.3,1.5.57L88.62,221Zm-2.17-1c-.51-.25-1-.52-1.5-.8l1.81-1.09c.45.23.89.45,1.35.66L86.45,220Zm-2.1-1.15q-.72-.45-1.41-.93l1.91-.91c.42.27.85.52,1.29.77l-1.79,1.07Zm-2-1.34q-.68-.51-1.32-1l2-.73c.4.31.8.6,1.21.88l-1.89.9ZM80.52,216c-.42-.37-.83-.75-1.23-1.15l2.08-.54c.37.34.74.66,1.12,1l-2,.71Zm-1.71-1.66c-.39-.41-.77-.83-1.12-1.26l2.12-.33c.34.37.69.72,1,1.07l-2,.52Zm-1.57-1.8q-.51-.66-1-1.35l2.16-.14c.29.4.61.78.93,1.15l-2.1.34Zm-1.39-1.94c-.31-.47-.6-.95-.88-1.44l2.11,0c.28.46.58.9.9,1.34l-2.13.13Zm-1.22-2c-.26-.49-.51-1-.75-1.52l2.11.18q.35.67.72,1.32l-2.08,0Zm-1-2.15c-.22-.52-.42-1.05-.61-1.58l2.1.39c.18.46.38.91.59,1.36l-2.08-.17Zm-.83-2.24c-.17-.53-.33-1.07-.47-1.62l2.06.6c.14.47.3.94.47,1.4l-2.06-.38Zm-.63-2.3c-.13-.55-.23-1.1-.33-1.65l2,.8c.1.49.21,1,.34,1.44l-2-.59Zm-.43-2.35q-.1-.84-.18-1.68l1.92.89c.06.53.14,1.06.23,1.58l-2-.79Zm-.22-2.37c0-.42,0-.84,0-1.27,0-.14,0-.28,0-.43l1.83,1.09c0,.5,0,1,.08,1.48l-1.89-.87Zm0-2.39q0-.85.12-1.68l1.73,1.27c0,.49,0,1,0,1.48l-1.8-1.07Zm.2-2.38c.07-.56.17-1.11.27-1.66l1.61,1.45q-.1.74-.18,1.47l-1.7-1.26Zm.42-2.35c.12-.55.26-1.1.41-1.64l1.5,1.5c-.13.51-.25,1-.34,1.57L72.11,190Zm.62-2.3c.16-.54.35-1.07.56-1.6l1.34,1.65c-.16.46-.3.94-.43,1.42l-1.47-1.47Zm.82-2.24c.21-.53.45-1,.7-1.54l1.19,1.78c-.21.45-.39.91-.57,1.38l-1.32-1.62Zm1-2.16c.26-.5.54-1,.83-1.47l1,1.9c-.23.43-.46.87-.68,1.31l-1.16-1.74Zm1.21-2.06c.3-.47.62-.93,1-1.39l.82,2c-.27.42-.54.83-.79,1.26l-1-1.86Zm1.38-1.95c.35-.44.71-.87,1.08-1.28l.64,2.06c-.31.39-.61.78-.9,1.18l-.82-2Zm1.55-1.81c.39-.41.79-.81,1.19-1.2l.53,2c-.37.38-.74.78-1.09,1.19l-.63-2Zm1.7-1.66c.42-.38.86-.75,1.3-1.1l.33,2.1c-.38.32-.75.66-1.11,1l-.52-2Zm1.85-1.52c.45-.34.91-.66,1.38-1l.13,2.13c-.4.29-.8.59-1.18.9l-.33-2.06Zm2-1.35c.47-.29,1-.57,1.46-.84l-.08,2.14c-.43.25-.85.52-1.26.8l-.12-2.1Zm2.08-1.16c.5-.25,1-.49,1.53-.71l-.3,2.13c-.44.22-.88.45-1.31.69l.08-2.11Zm2.18-1c.51-.21,1-.39,1.58-.56l-.5,2.11c-.46.17-.92.36-1.37.55l.29-2.1Zm2.25-.77c.54-.16,1.09-.31,1.64-.43l-.6,2c-.51.14-1,.3-1.53.47l.49-2.07Zm2.31-.58c.56-.11,1.11-.2,1.67-.27l-.79,2c-.49.09-1,.19-1.46.31l.58-2Zm2.37-.36c.55-.06,1.11-.1,1.68-.13l-1,1.9c-.49,0-1,.1-1.46.17l.79-1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M98.38,170.88a25,25,0,1,1-25,25A25,25,0,0,1,98.38,170.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M98.38,171.65a24.23,24.23,0,1,1-24.23,24.22,24.22,24.22,0,0,1,24.23-24.22Zm0,.58a23.65,23.65,0,1,1-23.65,23.64,23.65,23.65,0,0,1,23.65-23.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M98.38,173a22.86,22.86,0,1,1-22.87,22.87A22.87,22.87,0,0,1,98.38,173Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M99.71,178.3A18.91,18.91,0,1,1,80.8,197.21,18.92,18.92,0,0,1,99.71,178.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M98.38,181.43a14.45,14.45,0,1,1-14.45,14.45A14.44,14.44,0,0,1,98.38,181.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M98.38,184.7A11.18,11.18,0,1,1,87.2,195.88,11.18,11.18,0,0,1,98.38,184.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M110.76,195.43a6.21,6.21,0,0,0-.05-2c-.22-.58-.49-.58-1-.39a8.26,8.26,0,0,1-1.53.31l-.08,1.94,2.63.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M110.8,195l-2.17-.4L108,195q-.41,6.6-6.9,10.39l-.12,1.75,1.52.71c5.57-2,8.72-6,8.33-12.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M110.8,195l-.6-.11c-.29,6.56-3.22,10.7-8.54,12.64l.81.38c5.57-2,8.72-6,8.33-12.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M112.61,189.05l.09.29-.11-.28h0l-.15,0-.56.46.07.16.72-.07.12-.1,2.23,0,.87.18.77.23h0l-5,0-.21-.11v-.23l3.51-3.46-.4.71-.48.68L112.6,189h0l0,0Zm1.33,8.8.07-.06-.07.06ZM105.2,210.1l-.29.1.16-.07.14-.06,0-.16-.46-.54-.17.06.07.73.1.12,0,2.22-.19.88-.23.77h0l0-5,.11-.19h.24l3.45,3.51-.7-.4-.68-.48-1.51-1.49Zm7.16-9-.06.16.59.5H113v0l.18-.5,0-.07-.79-.06Zm.78.77,1.33,1.54.44.63.5.79-3.5-3.63,0-.24.2-.13,4.83.27-.81.16-.74.06-1.88-.06-.14.15-.13.25,0,.1v.11Zm-20,8.79,0-.43,0-.34L93,209.8l-.49.58v.13h0l.5.17h0l.06-.05Zm-9-7.93-.1-.3v0l.07.17.06.15h.16l.55-.47-.06-.17-.73.08-.12.09-2.22,0-.88-.19-.76-.23h0l5,0,.2.11v.24L81.8,205.6l.4-.7.48-.68,1.49-1.5,0,0ZM90.87,212l-.63.44-.79.49,3.63-3.5.24,0,.13.19-.26,4.84-.16-.82-.06-.75L93,211l-.15-.16-.25-.11-.11-.06h-.1L90.87,212Zm-7.25-21.35.78.06.06-.17-.59-.49h-.12v0l-.17.5.05.07Zm-2.19-.16,1.87.06.15-.15.12-.25.05-.11v-.1l-1.33-1.55-.43-.62-.5-.79,3.49,3.62.05.24-.2.13-4.83-.26.81-.16.75-.06Zm10.11-8.8h0l.3-.11-.12.05-.19.09,0,.15.46.55.17-.07-.07-.72-.1-.12,0-2.23.18-.87.24-.77h0l0,5-.11.2h-.24l-3.46-3.51.71.4.67.48,1.51,1.49Zm12.69-.45-.51-.17h0l0,0-.07.05h0l0,.43,0,.34.17.07.49-.59v-.15Zm-.44-2.29-.05,1.87.15.15.25.12.11.05h.1l1.54-1.33.63-.44.79-.5-3.63,3.5-.24,0-.13-.19.26-4.84.17.81.05.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M97.56,190.63l.38-.76.76-.53.83-.24,1-2,.85-1.83.63-1.68.36-1.7.24-4-.2-.54-.77-.43,2,.44-.26,4.84.13.19.24,0,3.63-3.5,1.73,1-.93-.14-.64.29-2.91,2.79-1.21,1.47-1,1.46-1,1.73-.9,1.93.06.06.55.61.3.81.46.64.46.15,1.64-.28,3.2-.92,1.92-.65,1.71-1,3-2.9.25-.47,0-.63.9,1.36-3.51,3.46v.23l.21.11,5,0h0l.33,1.13.2,1-.4-.67-.73-.41-4.39,0-2.26.25-2,.38-3.4.66-1.64.35-.08,0h0L101,193l-.84.19-1.08.11h0l-.75-.24-.69-.66-.35-.88,0-.51.2-.08,0-.32Zm-3.07,8.46h0l1.26-.35.84-.19,1.09-.12h0l.76.24.69.66.34.87,0,.51-.19.09,0,.32-.37.76-.76.53-.83.24-1,2-.85,1.83-.62,1.69-.37,1.7-.23,4,.19.55.77.43-2-.44.26-4.84-.13-.19-.24,0-3.63,3.5-1.73-1,.94.14.63-.29,2.92-2.79,1.2-1.47,1-1.47,1-1.73.9-1.92-.06-.07-.55-.61-.3-.8-.45-.65-.47-.14-1.64.28-3.2.92-1.91.65L86,203l-3,2.9-.25.47,0,.62-.91-1.35,3.51-3.46v-.24l-.2-.11-5,0h0l-.33-1.14-.19-1,.39.66.74.42,4.39,0,2.25-.26,2-.38,3.39-.66,1.64-.34.09,0ZM98.88,201l.06-.63-.26-.68-.54-.5-.7-.22-.67.11-.65.41-.33.63v.06l-.05.67.25.69.49.55.7.23.75-.15.61-.42.33-.67V201Zm-3.15-5-.8.65-.88.33-.5-.05-.08-.18-.34,0-.75-.39-.54-.76-.23-.82-2-1-1.83-.85-1.68-.63-1.71-.35-4-.24-.55.19-.42.78.44-2,4.83.26.2-.13-.05-.24L81.36,187h0l1-1.73-.14.94.28.63,2.79,2.92,1.48,1.2,1.46,1,1.73,1,1.93.9.67-.61.81-.3.65-.47.13-.46-.27-1.64-.92-3.2-.65-1.92-1-1.71-2.9-3-.47-.24-.63,0,1.36-.91,3.46,3.51h.24l.11-.2,0-5h0v0l1.13-.33,1-.2-.67.4-.41.74,0,4.4.27,2.24.37,2,.67,3.39.33,1.64,0,.09h0l.35,1.27.2.84.11,1.08h0l-.1.81Zm5.2.59.1-.8.81-.65.88-.33.5,0,.08.19.33,0,.75.38.54.76.23.83,2,1,1.82.85,1.68.62,1.71.36,4,.24.55-.2.43-.77-.45,2-4.83-.27-.2.13,0,.24,3.5,3.63-1,1.74.14-.94-.28-.63L111.45,202,110,200.85l-1.46-1-1.72-1-1.93-.9-.68.61-.81.3-.64.46-.14.47.27,1.64.93,3.19.64,1.92,1,1.72,2.9,3,.47.25.62,0-1.36.92L104.66,209h-.24l-.11.19,0,5h0v0l-1.1.31h0l-.26.06-.73.14.67-.39.42-.74,0-4.4-.26-2.24-.37-2.05L102,201.5l-.34-1.64,0-.09h0l-.36-1.27-.2-.84-.11-1.08v0Zm2.53-1.2-.63-.05-.68.26-.5.53-.22.71.11.67.41.65.63.32h.06l.67,0,.69-.24.55-.49.24-.7-.17-.75-.41-.62-.66-.33ZM101,191.62l0-.68-.25-.68-.48-.56-.71-.23-.74.16-.61.42-.34.66v.09l-.07.63.26.68.54.49.7.22.68-.1.65-.42.32-.62v-.06Zm-7.66,4.76.63.05.68-.26.49-.53.23-.71-.11-.68-.42-.64-.63-.33h-.05l-.68-.05-.69.25-.55.49-.23.7.16.75.41.61.67.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M101.17,214.9l-2,.19-2,0-2-.23-.77-.43-.19-.55.23-4,.37-1.7.62-1.69.85-1.83,1-2,.83-.24.76-.53.37-.76,0-.32.19-.09,0-.51-.34-.87-.64-.81.81-.17.73-.4.55-.61.35-.75.11,1.08.2.84.36,1.27,0,.08.34,1.64.67,3.38.37,2.05.26,2.24,0,4.4-.42.74-.67.39-1,.2Zm-16.75-8,1.23,1.4L87,209.57l1.22.91.49,0,1.74-2.15L94,201.77l.09-.49-.26-.46-.5-.18-.42.08-6.47,3.69-2.21,1.66-.06.48.25.36Zm-1.49-1h0l3-2.9,1.72-1,1.91-.65,3.2-.92,1.64-.28.47.14.45.65.3.81.55.6.06.07-.9,1.92-1,1.73-1,1.47-1.2,1.47-2.92,2.79-.63.29-.94-.14-1.61-1.21-1.48-1.36L83.3,207.8l-.59-.84,0-.62.25-.47Zm-3.37-6.21h0l-.2-1-.19-2h0l0-2h0l.24-2,.42-.78.55-.19,4,.24,1.71.35,1.68.63,1.83.85,2,1,.23.82.54.76.75.39.34,0,.08.18.5.05.88-.34.8-.64.17.82.4.71.61.57.76.34-1.09.12-.84.19-1.26.35-.08,0-1.64.34-3.39.66-2,.38-2.25.26-4.39,0-.74-.42-.39-.65Zm1-3.06.18,1.86.19.95.39.26,2.68-.58,7.08-2.18.47-.3.24-.47-.26-.45-.46-.34-7.34-1.95-2.6-.5-.36.27-.19,1.57,0,1.86Zm3.18-10.86,0,.5L86,188l6.53,3.53.48.09.47-.26.18-.5-.08-.41-3.7-6.48-1.65-2.2-.48-.07-.37.25L86,183.15l-1.27,1.36-.9,1.23Zm1.53,4h0l-2.79-2.92-.28-.63.14-.94,1.2-1.61,1.36-1.48,1.52-1.33.83-.59.63,0,.47.24,2.9,3,1,1.71.65,1.92.92,3.2.27,1.64-.13.46-.65.47-.8.3-.68.6L90,192.87l-1.73-1-1.46-1-1.48-1.2Zm12.63.17-.38.76,0,.32-.2.08,0,.51.35.88.63.81-.81.16-.72.4-.56.62-.35.74-.11-1.07-.2-.84L95.17,192l0-.08-.33-1.64-.67-3.39-.37-2-.27-2.24,0-4.4.41-.74.67-.4,1-.19,2-.19,2,0,2,.23.77.43.2.54-.24,4-.36,1.7-.63,1.68-.85,1.83-1,2-.83.24-.76.53Zm.18-.55.44-.26.34-.46,1.95-7.34.51-2.6-.27-.36-1.57-.19-1.86,0-1.86.18-1,.18-.27.4.58,2.69,2.18,7.07.31.47.47.24Zm4.81,1.6.5.18.42-.07,6.47-3.69,2.21-1.67.07-.47-.26-.36-1.23-1.4-1.37-1.27-1.23-.91-.49.05-1.73,2.14L102.76,190l-.09.47.26.46Zm-1.53,0h0l-.3-.81-.55-.61-.06-.07.9-1.92,1-1.73,1-1.46,1.21-1.47,2.91-2.79.64-.29.93.14,1.62,1.21,1.47,1.36,1.33,1.51.6.83,0,.63-.25.47-3,2.9-1.71,1-1.92.65-3.2.92-1.64.28-.46-.15-.46-.64Zm2.23,4.17-.33,0-.08-.19-.5,0-.88.33-.81.65-.16-.82-.41-.72-.61-.56-.76-.35,1.09-.11L101,193l1.26-.36.08,0,1.65-.35,3.39-.66,2-.38,2.26-.25,4.39,0,.73.41.4.67.19,1,.19,2,0,2-.23,2-.43.77-.55.2-4-.24-1.71-.36-1.68-.62-1.82-.85-2-1-.23-.83-.54-.76-.75-.38Zm1.3.56.27.45.45.33,7.34,2,2.6.5.37-.27.18-1.57,0-1.86-.17-1.86-.19-.95-.4-.27-2.68.59-7.08,2.17-.47.31-.24.47Zm-1.78,5.31.07.42,3.7,6.48,1.66,2.2.48.06h0l.36-.26,1.4-1.23,1.26-1.37L113,206l0-.5-2.14-1.73-6.53-3.53-.48-.08-.46.26-.18.49Zm-.56-1.1h0l.14-.47.64-.46.81-.3.68-.61,1.93.9,1.72,1,1.46,1,1.48,1.19,2.79,2.93.28.63-.14.94-1.2,1.6-1.36,1.49L110.3,211l-.83.58-.62,0-.47-.25-2.9-3-1-1.72-.64-1.92-.93-3.19-.27-1.64Zm-3.48,13.83,1.85-.17,1-.19.28-.39-.59-2.69-2.18-7.08-.3-.46-.47-.25-.45.27-.34.45-2,7.35-.51,2.59.27.37,1.57.19Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-48",
    points: "97.57 175.8 98.92 175.82 100.4 175.91 101.75 176.07 103.17 176.39 104.4 176.73 105.8 177.21 107.09 177.81 108.29 178.43 109.52 179.15 110.65 179.99 111.69 180.86 112.75 181.84 113.69 182.89 114.52 183.95 115.36 185.13 116.06 186.38 116.63 187.52 117.22 188.89 117.66 190.29 117.98 191.58 118.26 192.96 118.39 194.36 118.42 195.06 117.59 195.09 117.4 193.09 117.21 192.1 117.01 191.12 116.68 189.99 116.66 189.98 116.66 189.98 116.65 189.98 116.65 189.98 115.89 189.74 115.01 189.56 112.78 189.52 112.74 189.43 112.72 189.38 112.7 189.34 112.61 189.05 112.59 189.03 112.6 189.03 114.08 187.53 114.56 186.84 114.96 186.15 114.06 184.78 113.46 183.95 112.13 182.44 110.66 181.08 109.04 179.87 107.31 178.84 106.52 179.34 105.89 179.78 104.35 181.11 104.25 181.11 104.14 181.06 103.89 180.94 103.74 180.79 103.79 178.93 103.74 178.17 103.57 177.36 101.61 176.92 99.61 176.69 97.6 176.66 95.6 176.85 94.61 177.04 93.62 177.24 92.49 177.57 92.49 177.59 92.49 177.6 92.48 177.6 92.25 178.37 92.07 179.25 92.03 181.47 91.93 181.51 91.88 181.54 91.86 181.54 91.56 181.65 91.54 181.66 90.03 180.17 89.36 179.69 88.65 179.29 87.29 180.2 86.46 180.79 84.94 182.12 83.58 183.6 82.38 185.21 81.35 186.94 81.36 186.95 81.36 186.95 81.86 187.74 82.29 188.36 83.62 189.91 83.62 190.01 83.57 190.12 83.45 190.37 83.3 190.52 81.43 190.46 80.68 190.52 79.87 190.68 79.43 192.65 79.19 194.64 79.19 194.65 79.17 196.65 78.35 196.69 78.31 195.95 78.33 194.59 78.49 193.26 78.74 191.8 79.04 190.45 79.48 189.15 80.01 187.8 80.59 186.54 81.33 185.31 82.04 184.23 82.92 183.04 83.83 182.05 84.89 181.02 85.93 180.12 87.07 179.3 88.24 178.56 88.25 178.56 89.47 177.87 90.72 177.33 92.08 176.82 93.41 176.41 94.78 176.14 96.17 175.93 97.57 175.8 97.57 175.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "99.17 215.09 101.17 214.9 102.16 214.7 102.88 214.56 103.14 214.5 103.17 214.49 104.27 214.18 104.27 214.16 104.27 214.15 104.28 214.15 104.51 213.38 104.7 212.5 104.73 210.28 104.83 210.24 104.88 210.21 104.92 210.2 105.2 210.1 105.22 210.09 106.73 211.57 107.41 212.06 108.11 212.46 109.47 211.54 110.3 210.96 111.82 209.63 113.18 208.14 114.38 206.54 115.41 204.8 114.91 204.01 114.47 203.38 113.14 201.84 113.14 201.73 113.19 201.63 113.32 201.38 113.46 201.22 115.33 201.29 116.08 201.22 116.89 201.07 117.34 199.1 117.57 197.1 117.59 195.09 118.42 195.06 118.44 195.7 118.43 197.16 118.26 198.61 118.04 199.89 117.72 201.3 117.24 202.71 116.81 203.81 116.17 205.2 115.4 206.5 114.76 207.47 113.84 208.69 112.83 209.8 111.99 210.62 110.83 211.63 109.58 212.52 108.64 213.12 107.29 213.88 105.9 214.48 104.82 214.88 103.35 215.34 101.85 215.63 100.73 215.8 99.19 215.94 97.66 215.93 96.54 215.85 95.01 215.67 93.56 215.35 92.37 215.01 90.96 214.54 89.67 213.94 88.5 213.34 87.24 212.59 86.09 211.73 85.07 210.89 84.01 209.91 83.11 208.89 82.19 207.73 81.41 206.62 80.82 205.59 80.76 205.48 80.09 204.12 79.55 202.85 79.13 201.53 78.77 200.13 78.5 198.78 78.38 197.44 78.35 196.69 79.17 196.65 79.17 196.66 79.36 198.66 79.56 199.65 79.56 199.66 79.75 200.63 80.08 201.76 80.1 201.77 80.11 201.76 80.11 201.77 80.11 201.77 80.88 202 81.75 202.19 83.98 202.23 84.02 202.33 84.05 202.38 84.05 202.4 84.15 202.7 84.17 202.72 82.68 204.22 82.2 204.9 81.81 205.6 82.71 206.96 83.3 207.8 84.63 209.31 86.11 210.68 87.72 211.88 89.45 212.9 90.24 212.41 90.87 211.97 92.42 210.64 92.52 210.63 92.63 210.69 92.88 210.8 93.03 210.96 92.97 212.82 93.03 213.57 93.19 214.39 95.15 214.83 97.15 215.06 99.17 215.09 99.17 215.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M85.61,187.15l.5.44,6.52,3.6.34.06.26-.12.08-.29-.07-.35-3.83-6.43-.42-.47-.39-.08-1.24,1.09-1.11,1.21-.74,1h0l.1.35Zm9.79,25.93.51-2.59,2-7.35.34-.45.45-.27.47.25.3.46,2.18,7.08.59,2.69-.28.39-.57-1.3-.27-.6.29-.27-.13-.68-2-7.2-.23-.36-.33-.16-.3.16-.26.34-1.84,7.4-.06.59.27.29h0l0,.06-.22.55-.55,1.33-.27-.37Zm9.53-17.47.24-.47.47-.31,7.08-2.17,2.68-.59.4.27.19.95.17,1.86-2,.09-.15-1.65-.08-.4-.28-.29L113,193l-7.19,2-.37.23-.16.32-.3,0Zm-24.12-2.44.36-.27,2.6.5,7.34,1.95.46.34.26.45h-.3l-.16-.29-.34-.27-7.39-1.84-.59-.06-.29.27h0l-.09.9,0,1.64-2,.09,0-1.86.19-1.57Zm14.35-11.63-.58-2.69.27-.4,1-.18,1.86-.18,1.86,0,1.57.19.27.36-.51,2.6L98.9,188.6l-.34.46-.44.26-.47-.24-.31-.47-2.18-7.07Zm.53-1.18-.28.27.12.68,2,7.19.23.37.32.16.3-.16.26-.34,1.84-7.4.06-.59-.27-.29h0l-.89-.08-1.65,0-1.65.15-.4.09Zm7.07,9.63,3.53-6.54,1.73-2.14.49-.05,1.23.91,1.37,1.27,1.23,1.4.26.36-.07.47-2.21,1.67L103.85,191l-.42.07-.5-.18-.26-.46.09-.47Zm3.9-6.39h0l-3.6,6.53-.06.33.12.26.3.09.35-.08,6.43-3.83.47-.41.08-.39-1.1-1.24-1.21-1.12-1-.74-.34.1-.45.5ZM86,188h0l-2.14-1.72,0-.5.9-1.23L86,183.15l1.39-1.24.37-.25.48.07,1.65,2.2,3.7,6.48.08.41-.18.5-.47.26-.48-.09L86,188Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M80.78,198.46l-.18-1.86,2-.09.16,1.65.07.4.28.29.68-.13,7.19-2,.36-.22.16-.33h.3l-.24.47-.47.3L84,199.09l-2.68.58-.39-.26-.19-.95Zm16.46,15.18-1.57-.19.55-1.33.22-.55,0-.06.89.09,1.65,0,1.65-.16.4-.08.27.6.57,1.3-1,.19-1.85.17Zm16.88-16.75h0l0-1.64,2-.09,0,1.86-.18,1.57-.37.27-2.6-.5-7.34-2-.45-.33-.27-.45.3,0,.16.3.34.27,7.39,1.84.59.06.23-.21.06-.06h0l.1-.88Zm-10,3.67-.33-.06-.27.11-.08.3.08.35,3.83,6.43.41.47.39.07,1.24-1.08,1.11-1.21.75-1-.11-.35-.5-.44-6.52-3.6Zm-.91.78h0l-.07-.42.18-.49.46-.26.48.08,6.53,3.53,2.14,1.73,0,.5-.91,1.22-1.26,1.37-1.4,1.23-.36.26h0l-.48-.06-1.66-2.2-3.7-6.48Zm-16.66,3.51-.46.41-.08.39,1.09,1.24L88.32,208l1,.74.35-.11.44-.49,3.6-6.53.06-.33-.12-.27-.3-.08L93,201l-6.43,3.84Zm-.91,3.46h0l-1.23-1.4-.25-.36.06-.48,2.21-1.66,6.47-3.69.42-.08.5.18.26.46-.09.49-3.52,6.52-1.74,2.15-.49,0L87,209.57l-1.38-1.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M100.61,194.39a2.63,2.63,0,1,1-3.6-1A2.63,2.63,0,0,1,100.61,194.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M101,190.26a1.83,1.83,0,1,1-2.49-.67A1.82,1.82,0,0,1,101,190.26Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "99.41 189.9 99.97 190.22 100.52 190.53 100.52 191.17 100.52 191.81 99.97 192.12 99.41 192.44 98.86 192.12 98.31 191.81 98.31 191.17 98.31 190.53 98.86 190.22 99.41 189.9 99.41 189.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M104.65,196a1.83,1.83,0,0,1-3.17,1.83,1.83,1.83,0,1,1,3.17-1.83Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "103.06 195.64 103.61 195.96 104.16 196.28 104.16 196.91 104.16 197.55 103.61 197.87 103.06 198.19 102.51 197.87 101.95 197.55 101.95 196.91 101.95 196.28 102.51 195.96 103.06 195.64 103.06 195.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M99,199.75a1.83,1.83,0,1,1-2.5-.67A1.83,1.83,0,0,1,99,199.75Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "97.41 199.39 97.97 199.71 98.51 200.02 98.51 200.66 98.51 201.29 97.97 201.61 97.41 201.93 96.86 201.61 96.31 201.29 96.31 200.66 96.31 200.02 96.86 199.71 97.41 199.39 97.41 199.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M95.28,194a1.83,1.83,0,1,1-2.5-.67A1.82,1.82,0,0,1,95.28,194Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "93.69 193.59 94.25 193.91 94.8 194.23 94.8 194.87 94.8 195.5 94.25 195.82 93.69 196.14 93.14 195.82 92.59 195.5 92.59 194.87 92.59 194.23 93.14 193.91 93.69 193.59 93.69 193.59"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M423,182.07c.94,0,0-.44-.47-.35.86-.77,1-4.95-.46-5.14.71-.87-.72-1.08-1.3-1.13-.91-.08-.76-1.61-.84-2.22a6.53,6.53,0,0,0,1.7-.25c-.47,0-1.9.47-1.8-.43h1.64a7.8,7.8,0,0,0-2.06-3.33c-.8-.65-1.86-.91-2.5-1.72a25.82,25.82,0,0,1-3.15-6.11c-.87-2.08-1.72-4.17-2.6-6.24-.45-1.07-3-5.44-1.12-6a29.42,29.42,0,0,0-3.93-4,30,30,0,0,0-4.61-2.94,141.6,141.6,0,0,0-15.09-7.55c-5.28-2.32-10.6-4.54-15.93-6.72-2.74-1.12-5.54-2.11-8.21-3.38a17.69,17.69,0,0,0-3.54-1.63c-1.16-.25-2.54.18-3.62-.41.9,0,2.79-.91,3-1.79.06-.29.92-.51.41-.78s-1.29,0-1.85.09c.17-.17,1.82-1.31.63-1.23a10.48,10.48,0,0,0-2.64.87,10.59,10.59,0,0,1-2.12.65,16.4,16.4,0,0,1-2.32-.12c-1.76,0-3.51.27-5.27.11-2.71-.26-4.85-2.63-7-4.06q-4.47-3-8.93-5.92c-5.84-3.89-11.52-8-17.27-12s-11.66-7.83-17.59-11.6c.35-.25,1.05-.5,1.28-.89s-.8-.8-1-.9a17.23,17.23,0,0,1,3.23-.91,56.79,56.79,0,0,0-6.19-3.22c-.8-.3-1.62-.56-2.41-.91-.18-.09-1.58-1-1.14-1-.26-.86-1.57-1.19-2.31-1.4-1.37-.4-2.74-.8-4.11-1.22A63.7,63.7,0,0,0,271.69,74l-2.36-.31c-.57-.08-.52.35-1.15,0-1.09-.59-3-.49-4.2-.64-3.58-.44-7.17-.65-10.76-.89s-7.17-.42-10.76-.56l-2.43-.1c-.36,0-.38.27-.67.26-.45,0-.86-.36-1.36-.42a20.4,20.4,0,0,0-2.71-.11c-7.17,0-14.34-.34-21.51-.45l-5.27-.09-2.66,0c-.63,0-1.19.25-1.79.24s-1-.28-1.55-.29l-2.49,0-5.59-.06c-7.32-.08-14.63-.14-21.94-.13q-22.14,0-44.26.35-14.85.24-29.7.53l-15,.31-7.41.15a19.31,19.31,0,0,0-3,.11c-.46.07-2,.65-2,0-4.66.07-9.31.19-14,.32-2.18.07-4.41,0-6.57.29a6.73,6.73,0,0,1-1.86.36,8.67,8.67,0,0,0-2.83,0c-2.25.31-4.51.55-6.75.88-1.19.17-2.65-.2-3.13,1.17A9.08,9.08,0,0,1,34.45,78a9.89,9.89,0,0,0-1.12,1.59,2,2,0,0,0-.24.71c-.05.51.42.48-.24.7.6.18.32.43.09.86a17.31,17.31,0,0,0-.81,1.61C31.66,84.56,28,122,26.74,121.9c.66.55.15,2.56.1,3.35q-.18,3.27-.37,6.54c-.07,1.36-.15,2.71-.22,4.06a4.36,4.36,0,0,1,0,1,11,11,0,0,0-.64,1.77c-.15,1.08-.66,3,1,2.83-.18,4.25-.42,8.49-.53,12.74a25.84,25.84,0,0,1-.19,4.4,13,13,0,0,1-.8,1.87,4.73,4.73,0,0,0-.13,2.18c.13,1.39.4,2.66-.54,3.82-1.09,1.34-1,2.55-1,4.21,0,2.07-.16,4.15-.21,6.22-.05,2.31.06,4.62,0,6.94h4.31c-1.87,1.56-4.47-.16-6.5.8-2.3,1.08-1.86,4.14-1.8,6.2a6.28,6.28,0,0,0,3.46,5.85c2.39,1.29,4.93,1.07,7.55,1,6.33-.26,12.73.08,19.06.18s12.72-.1,19.05.36a76.62,76.62,0,0,1,1.4-10,28.36,28.36,0,0,1,3.09-9.29,30.49,30.49,0,0,1,6-7.37q1.83-1.68,3.8-3.19a8.17,8.17,0,0,1,1.87-1.05l.95-.41c.27-.12,1.29-.39.59-.51a32.08,32.08,0,0,1,33.1,4.9A31.67,31.67,0,0,1,128.57,185a65.6,65.6,0,0,1,3.54,20.63c0,1-.36,1.91,1,2,1.57.1,3.19,0,4.77,0h11.09q11.07,0,22.14,0l44.2.16c29.35.1,58.69.14,88,.3l5.13,0,2.65,0a4.74,4.74,0,0,1,1.13.06c.37.1.44.28.84.16,1.41-.45,3.25-.1,4.75-.08.84,0,1.68,0,2.53,0,.55,0,2.07.26,2.47-.18s.09-1,.09-1.43c0-.84,0-1.68,0-2.51,0-1.77.06-3.54.22-5.3a53,53,0,0,1,2.09-10c1.67-5.74,4-11.34,8.1-15.79a33.39,33.39,0,0,1,13.1-8.61,28.67,28.67,0,0,1,17.73-.75c5.41,1.48,10.92,4.22,14.38,8.77,3.18,4.19,4.78,9.38,5.86,14.46a63.07,63.07,0,0,1,1.39,8.95,23.11,23.11,0,0,1-.14,4.24c-.12,1.2-.43,2.91.22,4,.76,1.33,3.18.77,4.4.7,2.48-.13,5-.26,7.46-.32a105.65,105.65,0,0,0,11.26-.4c3.53-.45,7.22-1.51,9.68-4.23.82-.9,2.69-3.1,1.25-4.19-.61-.47-1.34-.42-2-.74s-.46-2.63-.46-3.26c.48,0,4.81.4,4.25-.82-.45-1-3.23-.64-4.09-.64.15-1-.14-2.68.92-3.21s2.2,0,3.13-.65c.5-.36.53-1.49.7-2.09.22-.75.44-1.5.65-2.25ZM306.69,131.28,278,128.79l-32.88-2.86c-.72-.06-.47-.51-.5-1.21l-.3-6.49q-.48-10.44-1-20.89Q243,90,242.67,82.7c0-.45-.09-.42.42-.46s1.17-.07,1.76-.09c3.14-.11,6.29-.06,9.43.12,9.92.57,20.18,2.39,29,7.06,4.82,2.54,9.38,5.68,14,8.57,1.95,1.21,3.89,2.42,5.82,3.65.19.12.89.41.92.66l.57,5.6q1,10,2.08,20.06c.12,1.13.24,2.25.35,3.38a.72.72,0,0,0-.38,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "contour",
    className: "cls-59",
    d: "M312.81,208.85a1.25,1.25,0,0,1-.49-.13l-.22-.09a2,2,0,0,0-.48,0h-.47l-2.72,0c-1.71,0-3.42,0-5.13-.05-19.25-.11-38.83-.16-57.77-.22q-15.12,0-30.25-.09l-44.2-.16q-11.07,0-22.14,0c-3.7,0-7.39,0-11.09,0h-.12l-1.63,0c-1,0-2,.05-3,0a1.53,1.53,0,0,1-1.1-.43,1.88,1.88,0,0,1-.27-1.44c0-.17,0-.34,0-.51a64.73,64.73,0,0,0-3.52-20.5,31.12,31.12,0,0,0-9.3-13.56,31.89,31.89,0,0,0-20.46-7.38,30.48,30.48,0,0,0-11.75,2.33c0,.35-.4.49-.85.64l-.21.08-.6.26-.35.16a7.78,7.78,0,0,0-1.79,1c-1.4,1.09-2.64,2.13-3.77,3.17a30.24,30.24,0,0,0-5.94,7.27,27.62,27.62,0,0,0-3,9.16c-.11.66-.22,1.31-.34,2a56.22,56.22,0,0,0-1.05,8l0,.41-.41,0c-4.32-.31-8.74-.31-13-.32-2,0-4,0-6,0-1.79,0-3.59-.08-5.39-.13-2.82-.07-5.74-.15-8.6-.15-1.83,0-3.49,0-5,.1l-.56,0c-.7,0-1.39.06-2.06.06a10.4,10.4,0,0,1-5.14-1.1,6.62,6.62,0,0,1-3.66-6.17c0-.22,0-.46,0-.7-.09-2-.23-4.8,2.06-5.88a4.25,4.25,0,0,1,2-.35v-.12c.05-1.27,0-2.56,0-3.81,0-1,0-2.08,0-3.12,0-.87.05-1.74.09-2.61.06-1.18.11-2.41.11-3.6v-.4a5.55,5.55,0,0,1,1.06-4.06c.73-.89.62-1.89.5-3l-.05-.5a5.43,5.43,0,0,1,.15-2.35,7.63,7.63,0,0,1,.36-.76,3.87,3.87,0,0,0,.43-1.05,14.47,14.47,0,0,0,.18-3c0-.43,0-.87,0-1.31.08-2.84.21-5.73.34-8.53l.18-3.8a1.21,1.21,0,0,1-.85-.41,3.24,3.24,0,0,1-.22-2.51c0-.13,0-.25.05-.36a4.21,4.21,0,0,1,.4-1.18,6.29,6.29,0,0,0,.26-.65,1.42,1.42,0,0,0,0-.51,3,3,0,0,1,0-.42l.59-10.6c0-.2,0-.46.1-.76.09-.64.28-2-.06-2.27l.29-.7h0a.35.35,0,0,0-.25.09c.8-1.06,2.7-17.47,3.84-27.28.89-7.67,1.24-10.61,1.4-11s.5-1,.76-1.52l.07-.13.12-.2a.22.22,0,0,1,0-.08h0v-.72a1.23,1.23,0,0,1,0-.4,2.36,2.36,0,0,1,.29-.86,10.72,10.72,0,0,1,1.11-1.59A7.82,7.82,0,0,0,35.51,75l.1-.28c.45-1.3,1.65-1.34,2.61-1.38a7.55,7.55,0,0,0,.83,0c1.27-.19,2.53-.35,3.8-.5l2.95-.38a8.88,8.88,0,0,1,3,0,2.21,2.21,0,0,0,1-.17,4.13,4.13,0,0,1,.77-.19,44.45,44.45,0,0,1,4.88-.26c.58,0,1.16,0,1.73,0,5-.15,9.6-.26,14-.33h.4v.3h.09a4.89,4.89,0,0,0,1.08-.21c.18,0,.32-.08.42-.09a10.14,10.14,0,0,1,1.7-.12h1.32l11.85-.25,10.58-.22c8.74-.17,18.18-.34,29.71-.52,14.13-.23,28.61-.34,44.26-.36h1.08c6.3,0,13.12,0,20.86.13l8.08.1a3.19,3.19,0,0,1,.89.16,3.3,3.3,0,0,0,.67.13h0a4.07,4.07,0,0,0,.78-.11,4.28,4.28,0,0,1,1-.14l8,.13c2.79,0,5.62.13,8.36.21,4.12.12,8.38.24,12.57.24h.78a20.92,20.92,0,0,1,2.55.12,2.47,2.47,0,0,1,.78.24,1.55,1.55,0,0,0,.55.17.86.86,0,0,1,.63-.26l2.47.1c3.54.14,7.16.34,10.76.57l.79,0c3.28.21,6.67.43,10,.84.34,0,.72.06,1.12.08a7.92,7.92,0,0,1,3.23.61.5.5,0,0,0,.22.08l.09,0a1.23,1.23,0,0,1,.7-.11l2.37.32a64.87,64.87,0,0,1,9.89,2.29c1.26.39,2.53.76,3.8,1.13l.44.13c.85.24,2.13.61,2.44,1.62l.05.15a7.87,7.87,0,0,0,.88.59c.51.22,1.05.42,1.58.61l.8.29A31.38,31.38,0,0,1,296,82.68c.61.35,1.22.7,1.83,1l-.1.74a22.93,22.93,0,0,0-2.41.6,1.12,1.12,0,0,1,.46.57.59.59,0,0,1-.06.45,2.15,2.15,0,0,1-.86.71C301.84,91.18,307.11,94.66,312,98c1.79,1.24,3.56,2.49,5.34,3.74,3.89,2.73,7.91,5.56,11.93,8.24,2.29,1.53,4.58,3,6.88,4.56l2,1.36c.61.4,1.22.87,1.81,1.34,1.56,1.21,3.17,2.48,5,2.65a22.76,22.76,0,0,0,3.29,0c.65,0,1.29-.07,1.94-.08h0a7.53,7.53,0,0,1,1,.08,4.42,4.42,0,0,0,1.25,0,9,9,0,0,0,1.86-.56l.19-.07.59-.24a6.88,6.88,0,0,1,2.16-.65c.58,0,.75.18.82.37a.69.69,0,0,1-.17.65,1.59,1.59,0,0,1,.77.16.62.62,0,0,1,.38.5c0,.32-.25.51-.44.65l-.17.13c-.12.62-.9,1.19-1.72,1.58h1a6,6,0,0,1,1.13.09,10.46,10.46,0,0,1,2.58,1.12c.35.19.7.38,1,.54,1.8.85,3.7,1.6,5.53,2.32.89.34,1.78.69,2.66,1,6.4,2.62,11.32,4.7,15.94,6.73a139.41,139.41,0,0,1,15.13,7.57l1.06.6a22.08,22.08,0,0,1,3.61,2.38,28.71,28.71,0,0,1,4,4.1l.36.47-.57.15a.48.48,0,0,0-.32.26c-.4.89.78,3.27,1.35,4.42.15.31.28.57.36.75q1,2.43,2,4.87l.76,1.83a23.21,23.21,0,0,0,2.9,5.55,4.09,4.09,0,0,0,1.32,1,7,7,0,0,1,1.12.71,8,8,0,0,1,2.19,3.49l.2.54h-.35l.07.4a4.58,4.58,0,0,1-1.4.24h0a.22.22,0,0,1,0,.08c0,.69.09,1.35.45,1.39,1,.08,1.6.35,1.79.79a.74.74,0,0,1,0,.52,2,2,0,0,1,.73,1.14,6.66,6.66,0,0,1-.15,3.88c.28.09.57.25.58.56s-.25.44-.48.48l-.57,2a5.38,5.38,0,0,0-.12.56,2.67,2.67,0,0,1-.73,1.74,3.23,3.23,0,0,1-1.93.49,3,3,0,0,0-1.26.2c-.59.29-.62,1.21-.65,2,0,.14,0,.28,0,.41h.13c.33,0,.73,0,1.15,0,1.07,0,2.36.1,2.74.92a.8.8,0,0,1,0,.77c-.3.46-1.13.67-2.71.67-.57,0-1.12,0-1.49-.05v.07c-.07,1.86.1,2.35.26,2.43a3.91,3.91,0,0,0,.73.24,3.25,3.25,0,0,1,1.3.54,1.65,1.65,0,0,1,.68,1.18c.12,1.23-1,2.63-1.87,3.59-2.13,2.35-5.37,3.77-9.93,4.35a67.11,67.11,0,0,1-8.24.38c-1,0-2,0-3.06,0-2.33.05-4.7.18-7,.3l-.47,0c-.21,0-.46,0-.73.07a14.56,14.56,0,0,1-1.53.1,2.63,2.63,0,0,1-2.51-1.07,6.48,6.48,0,0,1-.31-3.83l.05-.44a23.41,23.41,0,0,0,.14-4.16A63.87,63.87,0,0,0,384,187c-.92-4.32-2.41-9.85-5.79-14.3-3.76-5-9.78-7.43-14.17-8.62a28.29,28.29,0,0,0-17.48.73,33.37,33.37,0,0,0-13,8.5c-3.45,3.78-6,8.75-8,15.64a53,53,0,0,0-2.08,10c-.17,1.89-.2,3.8-.22,5.26v2.51a2.12,2.12,0,0,0,0,.33,1.68,1.68,0,0,1-.23,1.36,1.73,1.73,0,0,1-1.35.39c-.32,0-.65,0-.92,0l-.48,0h-.62c-.64,0-1.29,0-1.94,0-.42,0-.87,0-1.34-.07s-1.07-.07-1.6-.07a5.27,5.27,0,0,0-1.67.21,1.23,1.23,0,0,1-.36.06Zm-1.19-1.06a2.59,2.59,0,0,1,.7.08,2.45,2.45,0,0,1,.34.13c.15.07.11.08.27,0a6.19,6.19,0,0,1,1.91-.25c.56,0,1.12,0,1.66.08s.89.07,1.3.07l1.92,0h.61l.55,0c.26,0,.56,0,.86,0,.64,0,.76-.12.76-.12s.06-.49,0-.74a3.59,3.59,0,0,1,0-.43v-2.52c0-1.47.05-3.4.22-5.32a53.71,53.71,0,0,1,2.11-10.12c2-7,4.64-12.08,8.18-16a34,34,0,0,1,13.26-8.71,29.1,29.1,0,0,1,18-.76c4.5,1.23,10.7,3.78,14.6,8.91,3.47,4.58,5,10.22,5.93,14.62a64.86,64.86,0,0,1,1.4,9,25.08,25.08,0,0,1-.14,4.31l0,.44a5.91,5.91,0,0,0,.21,3.34c.26.46.84.68,1.82.68a13.38,13.38,0,0,0,1.45-.1l.77-.07.47,0c2.29-.12,4.66-.24,7-.29,1,0,2.05,0,3.07,0a69.46,69.46,0,0,0,8.15-.37c4.36-.56,7.44-1.9,9.44-4.11,1.17-1.3,1.74-2.3,1.67-3a.83.83,0,0,0-.37-.62,2.51,2.51,0,0,0-1-.4,4.53,4.53,0,0,1-.9-.3c-.74-.37-.76-1.71-.7-3.17,0-.19,0-.34,0-.45v-.4h.41l.38,0c.35,0,.91.05,1.49.05,1.81,0,2-.3,2-.31s-.41-.47-2-.47c-.4,0-.79,0-1.12,0l-.59,0h-.47l.07-.46a5.92,5.92,0,0,0,.06-.79c0-1,.08-2.21,1.09-2.71a3.83,3.83,0,0,1,1.59-.29,2.5,2.5,0,0,0,1.48-.33c.23-.17.34-.79.42-1.24a5.73,5.73,0,0,1,.13-.63l.64-2.21-.34-.59c.41-.37.74-2.36.34-3.68-.09-.27-.27-.73-.59-.77l-.71-.09.45-.55c.11-.12.11-.18.11-.18a2.08,2.08,0,0,0-1.13-.31c-1.08-.09-1.14-1.37-1.17-2.13,0-.17,0-.32,0-.43l0-.3a.84.84,0,0,1-.06-.47l0-.35h1.42a6.46,6.46,0,0,0-1.74-2.63,5.73,5.73,0,0,0-1-.62,4.85,4.85,0,0,1-1.56-1.17,23.44,23.44,0,0,1-3-5.74l-.76-1.83c-.68-1.62-1.35-3.25-2-4.87a6,6,0,0,0-.34-.7c-1-2-1.85-4-1.35-5.09a1.14,1.14,0,0,1,.33-.44,29.36,29.36,0,0,0-3.58-3.62,21.56,21.56,0,0,0-3.48-2.29l-1.08-.61a141.38,141.38,0,0,0-15-7.53c-4.62-2-9.53-4.1-15.92-6.71-.87-.36-1.76-.71-2.65-1.06-1.84-.72-3.75-1.47-5.58-2.34-.35-.16-.71-.36-1.08-.56a9.58,9.58,0,0,0-2.37-1,4.66,4.66,0,0,0-1-.08h-.85a3.94,3.94,0,0,1-1.92-.38l.17-.74c.88,0,2.48-.89,2.61-1.48a.75.75,0,0,1,.27-.42,3.15,3.15,0,0,0-.71.11c-.21,0-.41.08-.59.1l-.31-.68.21-.18c.16-.12.3-.23.41-.33a9,9,0,0,0-1.58.55l-.63.25-.18.07a9.81,9.81,0,0,1-2,.6,5.14,5.14,0,0,1-1.47,0,6.7,6.7,0,0,0-.87-.08c-.67,0-1.3.05-1.93.08a23.1,23.1,0,0,1-3.42,0c-2.08-.2-3.79-1.53-5.43-2.82-.61-.47-1.18-.92-1.76-1.3l-2.06-1.36c-2.29-1.52-4.59-3-6.88-4.56-4-2.69-8.06-5.52-11.95-8.25l-5.33-3.74c-4.95-3.45-10.38-7-17.58-11.59l-.49-.31.48-.34a4,4,0,0,1,.48-.3,3.1,3.1,0,0,0,.6-.38,3.06,3.06,0,0,0-.62-.39l-.79-.47.71-.3a13.36,13.36,0,0,1,2.28-.71l-.92-.52a30.4,30.4,0,0,0-4.3-2.17l-.79-.29c-.54-.19-1.1-.39-1.64-.63,0,0-1.58-.79-1.45-1.39v0a3.47,3.47,0,0,0-1.81-.91l-.44-.13c-1.28-.37-2.54-.74-3.81-1.13a64.17,64.17,0,0,0-9.77-2.26l-2.36-.32a.39.39,0,0,0-.28,0,1.13,1.13,0,0,1-1-.09,7.55,7.55,0,0,0-2.89-.51c-.43,0-.83,0-1.17-.09-3.3-.4-6.69-.62-10-.83l-.79-.05c-3.6-.23-7.21-.42-10.74-.57l-2.43-.1a.18.18,0,0,0-.12.06.79.79,0,0,1-.52.2,2.27,2.27,0,0,1-.86-.23,1.82,1.82,0,0,0-.57-.19,21,21,0,0,0-2.45-.11h-.78c-4.2,0-8.47-.12-12.59-.24-2.74-.08-5.57-.16-8.35-.2l-7.94-.13h0a3.68,3.68,0,0,0-.82.11,4.63,4.63,0,0,1-.93.13,3.81,3.81,0,0,1-.9-.16,2.53,2.53,0,0,0-.69-.13L194.42,71c-7.73-.09-14.55-.14-20.85-.14h-1.08c-15.65,0-30.13.12-44.25.35-11.53.18-21,.35-29.7.52L88,71.91l-11.85.25H74.77a9.53,9.53,0,0,0-1.57.1l-.35.08a3.06,3.06,0,0,1-1.82.11.91.91,0,0,1-.21-.18c-4.28.07-8.76.17-13.69.32l-1.73,0a45.43,45.43,0,0,0-4.81.24A5.53,5.53,0,0,0,50,73a2.89,2.89,0,0,1-1.33.19,8.53,8.53,0,0,0-2.72,0c-1,.14-2,.26-3,.38-1.26.16-2.53.32-3.79.5-.29,0-.6,0-.91.07-1,0-1.63.09-1.89.84l-.1.28a8.64,8.64,0,0,1-1.5,3,9.49,9.49,0,0,0-1.08,1.52,1.75,1.75,0,0,0-.2.57.26.26,0,0,0,0,.18.51.51,0,0,1,0,.46.08.08,0,0,1,0,0l0,.06a.89.89,0,0,1-.18.79l-.1.18-.07.13c-.26.47-.52,1-.73,1.45s-.73,5.46-1.34,10.78c-2.38,20.56-3.24,26.1-3.92,27.47a4.72,4.72,0,0,1,.09,2.71c0,.28-.07.52-.08.69l-.6,10.6c0,.12,0,.22,0,.33a2.22,2.22,0,0,1-.06.79c-.09.27-.2.51-.3.75a3.47,3.47,0,0,0-.33.95l-.06.39c-.1.61-.24,1.53,0,1.86,0,.05.2.19.61.14L27,141l0,.46c-.06,1.41-.13,2.81-.19,4.22-.13,2.79-.27,5.68-.35,8.51,0,.43,0,.86,0,1.29a15.53,15.53,0,0,1-.19,3.18,5,5,0,0,1-.51,1.26c-.11.22-.22.43-.32.68a4.58,4.58,0,0,0-.1,2l.05.48a4.5,4.5,0,0,1-.67,3.63,4.82,4.82,0,0,0-.89,3.55v.41c0,1.21,0,2.44-.11,3.63,0,.87-.07,1.73-.09,2.6,0,1,0,2.06,0,3.09s0,2.29,0,3.44h3.9l.25.7a3.61,3.61,0,0,1-2.42.78,13.36,13.36,0,0,1-1.41-.1,12.84,12.84,0,0,0-1.34-.1,3.28,3.28,0,0,0-1.41.27c-1.81.86-1.7,3.23-1.6,5.13,0,.25,0,.49,0,.71a5.83,5.83,0,0,0,3.25,5.51,9.72,9.72,0,0,0,4.76,1c.66,0,1.34,0,2-.06l.57,0c1.57-.06,3.24-.09,5.08-.09,2.87,0,5.8.08,8.63.15,1.79,0,3.58.1,5.37.13,2,0,4,0,6,0,4.15,0,8.44,0,12.66.3A59,59,0,0,1,69,190.1c.11-.66.23-1.31.34-2a28.19,28.19,0,0,1,3.14-9.42,30.64,30.64,0,0,1,6.08-7.46c1.15-1.06,2.4-2.11,3.82-3.21a9,9,0,0,1,2-1.1l.36-.15.59-.26.27-.1.35-.14,0-.27a31,31,0,0,1,12.55-2.61,32.69,32.69,0,0,1,21,7.57,31.76,31.76,0,0,1,9.54,13.91,65.4,65.4,0,0,1,3.56,20.75c0,.19,0,.38,0,.56,0,.37,0,.72.08.86a.83.83,0,0,0,.54.17c1,.06,2,0,3,0l1.65,0h.12c3.7,0,7.39,0,11.09,0q11.07,0,22.14,0l44.2.16,30.25.09c18.94.05,38.52.11,57.78.22l5.13,0,2.65,0Zm-4.09-76-.41-.13v.05l-62-5.39c-.93-.08-.9-.77-.87-1.18,0-.12,0-.26,0-.41l-2-42.16c-.05-.63.29-.7.73-.73.65,0,1.24-.07,1.83-.09,3-.12,6.2-.08,9.47.11,11.89.69,21.45,3,29.22,7.11,3.47,1.83,6.86,4,10.13,6.1q2,1.26,3.89,2.48l.4.25c1.81,1.13,3.62,2.26,5.43,3.41l.16.09c.51.26.89.48.93.86l3.07,29.63ZM245,125.52l.15,0,61.47,5.34h0l-3-28.56a2.67,2.67,0,0,0-.51-.31l-.23-.12c-1.8-1.15-3.61-2.28-5.43-3.41l-.38-.24q-2-1.23-3.91-2.49c-3.26-2.09-6.63-4.25-10.07-6.07-7.67-4-17.12-6.34-28.89-7-3.25-.19-6.41-.22-9.4-.11-.58,0-1.16,0-1.74.08h-.06v0l2,42c0,.18,0,.35,0,.5a1.69,1.69,0,0,0,0,.32Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "locks"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M226.83,139l-.05.9-.17.77-.52.38-4.17.44.25-.46,3.82-.26.41-.28.16-.61,0-.88,0-.49-.38-.38-3.94-.56h0l-.12-.44,4.16.73.49.5.06.65Zm-22.34,1.13,3.81.46,1.84.22,0,.48-5.8-.8-.54-.91v-1.57l.24-1.45.66-.74,5.75.18-.19.43-1.66-.06-3.82-.14-.47.47-.25,1.35,0,1.39.4.69Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-60"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-61",
    points: "211.01 142.58 210.12 141.33 210.14 140.85 210.56 140.48 211.22 140.36 215.92 140.33 218.75 140.45 221.45 140.68 221.92 140.84 222.17 141.08 221.92 141.53 220.83 143.12 219.05 143.85 215.95 144.12 212.77 143.61 211.01 142.58 211.01 142.58"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "210.7 135.6 211.59 134.14 213.5 133.28 216.87 133.25 219.88 133.87 221.35 135.19 221.94 136.59 222.12 137.16 222.24 137.6 222.08 137.58 221.67 137.55 218.88 137.27 216.16 136.99 211.32 136.54 210.68 136.51 210.25 136.47 210.44 136.04 210.7 135.6 210.7 135.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-59",
    points: "208.59 136.41 208.67 136.55 208.63 137.06 208.52 138.95 208.46 139.67 208.3 140.63 208.28 139.68 208.33 138.96 208.44 137.06 208.48 136.54 208.59 136.41 208.59 136.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M208.3,140.63l-3.81-.46-.4-.69,0-1.39.25-1.35.47-.47,3.82.14,1.67.06.42,0,.64,0,4.84.45,2.72.27,2.79.29.41,0,.16,0h0l3.94.56.38.38,0,.49,0,.88-.16.61-.41.28-3.82.26-.25-.23-.47-.16-2.7-.23-2.83-.12-4.7,0-.66.12-.42.37-1.84-.22Zm.29-4.22-.11.13,0,.52-.11,1.9-.05.72,0,.95.16-1,.06-.72.11-1.89,0-.51-.08-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M259.12,141.27l0,.9-.17.77-.53.39-4.16.43.25-.45,3.82-.27.4-.27.17-.62,0-.88-.05-.49-.38-.38-3.93-.56h0l-.11-.44,4.16.73.48.5.06.65Zm-22.33,1.13,3.8.47,1.84.21v.49l-5.81-.81-.54-.91,0-1.56.23-1.45.67-.75,5.75.19-.19.42-1.66-.06-3.82-.14-.48.47-.25,1.35,0,1.39.4.69Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-64"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-65",
    points: "243.31 144.81 242.42 143.56 242.43 143.08 242.86 142.71 243.52 142.59 248.22 142.56 251.04 142.68 253.75 142.91 254.21 143.07 254.47 143.31 254.22 143.76 253.12 145.35 251.34 146.09 248.25 146.35 245.07 145.84 243.31 144.81 243.31 144.81"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "242.99 137.84 243.88 136.38 245.8 135.51 249.16 135.48 252.18 136.1 253.65 137.43 254.23 138.82 254.42 139.39 254.53 139.83 254.37 139.81 253.96 139.78 251.18 139.5 248.46 139.22 243.61 138.77 242.97 138.74 242.55 138.7 242.74 138.28 242.99 137.84 242.99 137.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-59",
    points: "240.89 138.64 240.97 138.79 240.93 139.29 240.82 141.18 240.76 141.91 240.59 142.87 240.57 141.91 240.62 141.19 240.73 139.29 240.77 138.78 240.89 138.64 240.89 138.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M240.59,142.87l-3.8-.47-.4-.69,0-1.39.25-1.35.48-.47,3.82.14,1.66.06.42,0,.64,0,4.85.45,2.72.28,2.78.28.41,0,.16,0h0l3.93.56.38.38.05.49,0,.88-.17.61-.4.28-3.82.27-.26-.24-.47-.16-2.7-.23-2.82-.12-4.7,0-.66.12-.43.37-1.84-.21Zm.3-4.23-.12.14,0,.51-.11,1.9-.05.72,0,1,.17-1,.06-.73.1-1.89.05-.5-.08-.15Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "windscreen"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M352.92,120.26a4.66,4.66,0,0,1-.72.11c-.57,0-1.28-.17-2-.16-1.5,0-3,.2-4.55.15a6.82,6.82,0,0,0,1.35,0,56.71,56.71,0,0,1,6.24.17l-.34-.3Zm-9.74-.42a38.74,38.74,0,0,1-4.53-3.11c-4.84-3.2-9.7-6.39-14.51-9.66,3,2.1,5.18,3.62,6.29,4.34,2.91,1.88,12.31,8.29,12.31,8.29l.44.14Zm-25.1-17-2.14-1.53c-7.09-5.12-14.43-9.91-21.8-14.59,1.34-1,2-.79.31-1.79a18,18,0,0,1,3.23-.91l-5.52-2.93c-.94-.51-4.2-1.31-4.36-2.18h.14a.19.19,0,0,0,0-.08,12.42,12.42,0,0,0-2.53.84L283,80.89a225.11,225.11,0,0,1,21.12,12.57c5.2,3.41,9.94,6.64,14,9.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M288.37,78.76a13.91,13.91,0,0,0-3,.94L283,80.89a225.11,225.11,0,0,1,21.12,12.57c13.16,8.63,23.42,16.07,26.32,18s12.31,8.29,12.31,8.29a12.63,12.63,0,0,0,4.28.69,56.71,56.71,0,0,1,6.24.17s-23.94-22.06-64.89-41.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M344.34,120.1s3.89,2.4,4.93,3.07a13.41,13.41,0,0,0,2.35,1.14s1.78-.74,3.24-1.16a12.37,12.37,0,0,1,2.08-.47l-3.81-2.28a17.9,17.9,0,0,0-2.8-.2c-1.66,0-4.95.4-6-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M355.29,122.61l-.1,0a2.08,2.08,0,0,0,1.69,0,21.48,21.48,0,0,0,2.53-1.27l-.1-.53s.38-.06.43-.32-.65-.26-.65-.26l-2.12.12-2.78,1.47,1.1.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M346,121.22s3.94-.13,5.46-.13a21,21,0,0,0,2.33-.1l.05.55a22.88,22.88,0,0,1-2.38.1c-1.55,0-5.42.12-5.44.12l0-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M352.44,122.94a1.91,1.91,0,0,1-1-.37l-.44-.36.69-.57s-.83-.34-.25-.69a22.57,22.57,0,0,1,3.28-1c1-.31,3.07-.85,3.07-.85s.25-.1.31.12-.08.22-.67.46-3.64,1.88-3.64,1.88l-1.33,1.38Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "bumper"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M416,167.15l1.3-.67a68.79,68.79,0,0,0-5.8-14.72H409.4A67.32,67.32,0,0,0,416,167.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M423,182.07c1,0,.1-.47-.47-.35.76-.68.9-5-.46-5.14.74-.9-.7-1.08-1.3-1.13-.86-.08-.75-1.57-.84-2.22a7.19,7.19,0,0,0,1.7-.25c-.65,0-1.9.45-1.8-.43h1.64c-.59-1.55-1.4-3.17-2.87-3.83a2.11,2.11,0,0,1-.63-.45,2.22,2.22,0,0,1-.51-.23c-1.14-.72-3.15-5.23-4.06-7.55-.5-1.27-1.42-3.41-2.29-5.45l-5.42.65s-8.11,8-10.51,10.24-7.25,2.26-7.25,2.26l-17.59-2.07a35.2,35.2,0,0,1,3.39,1.92c7.55,4.88,9.94,14.56,11.37,22.85a42,42,0,0,1,.71,6.71c0,1.85-.71,4.65-.09,6.38.52,1.43,3.22,1,4.5.89,2-.1,4-.17,5.95-.27,7.52-.37,19.07,1.19,23.59-6.2,1.16-1.91.73-2.6-1.05-3.24-.71-.26-.93.15-1.11-.84-.13-.77-.18-7.35,1.68-7.42,1,0,3-.06,2.78-1.53l.94-3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M385.8,196.42c0,.4,0,.79,0,1.18,0,1.85-.71,4.65-.09,6.38.52,1.43,3.22,1,4.5.89,2-.1,4-.17,5.95-.27,7.52-.37,19.07,1.19,23.59-6.2a5.12,5.12,0,0,0,.51-1c-4.95,2.42-9,.95-16.67,1.12-8,.18-10.53-2-10.53-2s-.18.27-3.09.53a10.25,10.25,0,0,1-4.21-.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M419.57,195.52a5,5,0,0,0-.83-.36c-.71-.26-.93.15-1.11-.84-.13-.77-.18-7.35,1.68-7.42a4.16,4.16,0,0,0,2.53-.62H412.9a4.63,4.63,0,0,0-4.62,4.62h0a4.63,4.63,0,0,0,4.62,4.62Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-72"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M421,173.13a3.06,3.06,0,0,0,.63-.15c-.65,0-1.9.45-1.8-.43h1.64c-.59-1.55-1.4-3.17-2.87-3.83a2.11,2.11,0,0,1-.63-.45,1.86,1.86,0,0,1-.51-.23c-1.14-.72-3.15-5.23-4.06-7.55-.5-1.27-1.42-3.41-2.29-5.45l-5.42.65s-8.11,8-10.51,10.24-7.25,2.26-7.25,2.26l-17.59-2.07a35.2,35.2,0,0,1,3.39,1.92,18.81,18.81,0,0,1,3.37,2.82c6.25.81,18.37,2.27,24.67,2.27Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M396.82,176.84c-.69.2-1.1.56-1.16,1.11a3.33,3.33,0,0,0,3.23,3.47h23.87a3,3,0,0,0,.24-.76H400a3.34,3.34,0,0,1-3.23-3.47,1,1,0,0,1,.09-.35Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-74"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M422.25,176.62H398.89c-1.43,0-2.47.19-2.94.7h26.89a1.21,1.21,0,0,0-.59-.7Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M421.2,190.13H408.39v1.62H421.2a.81.81,0,0,0,.81-.81h0a.81.81,0,0,0-.81-.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "M421.2,190.13H408.39v.73H421.2a.83.83,0,0,0,.68-.37.82.82,0,0,0-.68-.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M422.6,189.9h0a.68.68,0,0,0,.68-.68v-7.93a.69.69,0,0,0-.68-.68h0a.68.68,0,0,0-.68.68v7.93a.67.67,0,0,0,.68.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M411.85,155.88l-.33-.76-5.42.64S398,163.81,395.59,166s-7.24,2.26-7.24,2.26l-17.6-2.07c.59.29,1.16.6,1.73.92L388.72,169s4.86-.06,7.25-2.26,10.51-10.24,10.51-10.24l5.37-.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M421.5,172.54c-.09-.24-.2-.49-.3-.74h-3.39a1,1,0,0,0-1,1v.32h.68a1,1,0,0,1,.92-.59Z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "lide_signal",
    "data-name": "lide signal"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M324.69,158.24h0a3.75,3.75,0,0,0-2,.44h0a1.39,1.39,0,0,0-.82,1.09,1.42,1.42,0,0,0,.73,1.15,3.88,3.88,0,0,0,2,.58h0a3.79,3.79,0,0,0,2-.44h0a1.38,1.38,0,0,0,.81-1.09,1.42,1.42,0,0,0-.73-1.15,3.88,3.88,0,0,0-2-.58Zm0-.44h0a4.24,4.24,0,0,1,2.2.66,1.62,1.62,0,0,1-.1,3h0a4.34,4.34,0,0,1-2.24.5h0a4.24,4.24,0,0,1-2.2-.66,1.81,1.81,0,0,1-.92-1.53,1.79,1.79,0,0,1,1-1.45h0a4.19,4.19,0,0,1,2.23-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M324.69,158c1.65.06,2.95.93,2.92,2s-1.41,1.8-3.05,1.74-2.95-.94-2.92-2S323,158,324.69,158Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M322.23,160.83h3.4s2-.07,2-.61a6.81,6.81,0,0,0-.19-.9,4.21,4.21,0,0,0-1.95-.7,14.92,14.92,0,0,0-2.37-.3,2.66,2.66,0,0,0-.85,2.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M322.23,160.83h3.4a7.17,7.17,0,0,0,.92-.09c-.56-.21-1.45-.63-1.1-1a5,5,0,0,1,1.13-.8,7.37,7.37,0,0,0-1.13-.3l-.94-.16a1,1,0,0,1-.4,1.32,3.67,3.67,0,0,1-1.89.5,3.42,3.42,0,0,0,0,.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M327.41,160.49a.29.29,0,0,0,.18-.27,6.81,6.81,0,0,0-.19-.9,1.42,1.42,0,0,0-.39-.23,1,1,0,0,0-.16.6.81.81,0,0,0,.56.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M326.28,159.47c-.48,0-.87.09-.86.2s.4.2.88.2.87-.09.86-.2-.4-.2-.88-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M324.8,160.61c-.75,0-1.37-.14-1.37-.32s.59-.32,1.34-.32,1.37.14,1.37.32-.59.32-1.34.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M325.56,158.88c-.38,0-.68.1-.67.22s.32.21.7.21.68-.09.68-.21-.32-.22-.71-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M323,158.67a.35.35,0,0,0-.36.36.4.4,0,0,0,.4.35.35.35,0,0,0,.35-.35.4.4,0,0,0-.39-.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M323,160.21a.35.35,0,0,1,.35.31.3.3,0,0,1-.32.31.35.35,0,0,1-.35-.31.3.3,0,0,1,.32-.31Z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "spot"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M385.33,149.55s-1.08-.77-.79-1.35c.16-.3,1-.49,1.9-.62,2.53-.41,10.89-1.55,14.6.71s7,5.46,8.54,8.82a89.7,89.7,0,0,1,3.24,8.92s.34,1.21-.8,1.21-3.92.43-8.67-2.47-13.43-9.05-18-15.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M400,149.43a34.47,34.47,0,0,0,.95,5.82c.63,1.89,3.2,9.05,3.2,9.05a11.85,11.85,0,0,0,3,1.44,11.43,11.43,0,0,0,1.76.18,10.81,10.81,0,0,1-.77-3.24,30.8,30.8,0,0,0-1.57-7.34,8.87,8.87,0,0,0-1.22-2.3s-3.24-3.61-5.32-3.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M400.1,150.67c.06.54.13,1.19.24,1.86.36-1.32.49-2.35.26-2.42s-.29.18-.5.56Zm.52,3.43c.09.42.19.81.3,1.15l.23.67c.16-.43.32-.9.47-1.4.59-2,.84-3.65.56-3.74s-1,1.39-1.56,3.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "M406.64,154.3a70.33,70.33,0,0,1,4,7.88c.77,2.3,1.31,3.92.81,4a12.66,12.66,0,0,1-2,0,16.9,16.9,0,0,1-.9-3.11c-.18-1.31-.85-6.44-1.89-8.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M402.81,157.54c2,0,3.56.3,3.56.68s-1.59.67-3.56.67-3.55-.3-3.55-.67S400.85,157.54,402.81,157.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M399.26,149.12s-9.11-1-11.27-.63-1.44,1.48-.45,2.88,8.83,7.84,10.72,9.37a42,42,0,0,0,5,3.24s-3.29-9-4-14.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M399.26,149.12s-9.11-1-11.27-.63-1.44,1.48-.45,2.88a27,27,0,0,0,2.85,2.75h9.84a42.46,42.46,0,0,1-1-5Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-88"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M384.59,148.14a3.94,3.94,0,0,1,1.85-.56c2.53-.41,10.89-1.55,14.6.71a23.48,23.48,0,0,1,7.91,7.6c-5.19.48-7.45-.39-10.12-1.76-3.11-1.59-8.48-4.47-14.24-6Z"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "rear_details",
    "data-name": "rear details"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M24.94,165.72A9.26,9.26,0,0,1,24,167c-.8,1-.47,2.72-.52,3.94-.12,3.44-.31,7.1-.18,10.66,0,.74,0,1.47,0,2.21l-.07.55-1.58.07A3.31,3.31,0,0,0,19.18,188c.11,2.08-.24,4.65.91,6.49a8.37,8.37,0,0,0,5.23,3.17,39,39,0,0,0,6,0c2.14,0,4.28,0,6.42,0,4.74.06,9.47.14,14.19.21,5.45.09,11-.08,16.39.32a76.07,76.07,0,0,1,1.34-9.61,30,30,0,0,1,2.29-8,28.6,28.6,0,0,1,6.26-8.46,56.44,56.44,0,0,1,4.41-3.76A11.18,11.18,0,0,1,85.29,167l-17.23-1.36-43.12.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M36.66,74a.88.88,0,0,0-.29.16,8.88,8.88,0,0,0-.89,2.41c-.34.92-3.1,3.34-2.23,4.31l-.4.13c.14,0,.27.18.42.23a18.59,18.59,0,0,0-1.39,2.92c-.27.88-4,34.85-4.38,35.12l-1.16,15.5.42,2.67-.09,4.4L26.08,154c-.09,1.69.26,4.67-.78,6.1s.19,4.09-.35,5.64A8.72,8.72,0,0,1,24,167c-.8,1-.47,2.72-.52,3.94-.12,3.44-.31,7.1-.18,10.66,0,.74,0,1.47,0,2.21h4.31c-1.58,1.32-4.13.23-6,.61a3.48,3.48,0,0,0-2.38,3.65c.11,2.08-.24,4.51.91,6.35a8.37,8.37,0,0,0,5.23,3.17,39,39,0,0,0,6,0c2.14,0,4.28,0,6.42,0,4.74.06,9.47.14,14.19.21,5.45.09,11-.08,16.39.32,0-.89.11-1.78.21-2.66l-21.5-.29s-9.82,1-11.08-4.79-.67-5.12-.67-5.12,2.26-1.43,2.43-6,0-12,0-12L39.07,166s-1.55-32.42-.42-50.61,2.57-28.66,6.28-33.49C48.26,77.51,46.64,74,36.66,74Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-91"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "M24.94,165.72A10.09,10.09,0,0,1,24,167a2.1,2.1,0,0,0-.29.5H84c.43-.2.86-.38,1.29-.56l-17.24-1.36-43.11.1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-93"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M23.18,184.08l0,.32-1.58.07a3,3,0,0,0-2.06,1.76H67.74l-3.19-2.15Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "M32.07,167.39s24.82.24,30.88.24,12.41,1.13,10.93,3.35a25.79,25.79,0,0,0-2.53,5.63,54.52,54.52,0,0,1,4.48-5.87A25.73,25.73,0,0,1,80.4,167l-4.71,2.28s3-1.89-.64-1.95-43,.08-43,.08Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-96"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "M26,134.36a15,15,0,0,0,.2,1.53c.25,1.33-.63,1.54-.7,3.08-.06,1.37-.63,2.7,1.06,2.5l0,.7h2.9c1.36,0,1.22-.14,1.33-.82s0-3.23.28-4.7-.64-1.22-.64-1.22-.4-.11-2.3-.36a5.37,5.37,0,0,1-2.1-.71Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M26,134.36a15,15,0,0,0,.2,1.53,2,2,0,0,1-.19,1.37H31c0-.22.06-.42.1-.61.28-1.47-.65-1.22-.65-1.22s-.4-.11-2.3-.36a5.37,5.37,0,0,1-2.1-.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M27.25,141.78H26.13a.43.43,0,0,1-.43-.43v-3.3a.43.43,0,0,1,.43-.43h1.12a.43.43,0,0,1,.43.43v3.3a.43.43,0,0,1-.43.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M33.1,80.21a.74.74,0,0,0,.15.65l-.4.13c.14,0,.27.18.42.23l-.09.17c1.37.47,2.94,1,3.84,1.43a10.54,10.54,0,0,1,1.74.91c-.43,1.07-1.55,4.6-3.33,15.21-1,5.77-1.82,14.43-2.48,23.13-.91,12.08-1.45,24.27-1.45,29,0,7.34-.29,13.38-.34,14.45l-1.39,1.83-.12.14v.19l.12,12h0s.2,4.17-3.14,4.17l-3.42,0h4.31c-1.58,1.32-4.13.23-6,.61a2.51,2.51,0,0,0-1,.51c2.27,0,4.58-.08,6.12-.08,4.49,0,4.23-5.27,4.23-5.29h0l-.11-11.79L32.14,166l.09-.14,0-.16s.34-6.61.34-14.68c0-4.68.55-16.83,1.45-28.88.66-8.68,1.5-17.3,2.46-23,2.29-13.61,3.39-15.25,3.39-15.26l.2-.33-.25-.29a6.37,6.37,0,0,0-2.39-1.42c-1-.45-2.88-1.11-4.35-1.61Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-98",
    points: "34.08 122.7 27.04 122.57 27.04 122.88 34.08 123.01 34.08 122.7 34.08 122.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "34.08 122.42 27.04 122.28 27.04 122.59 34.08 122.72 34.08 122.42 34.08 122.42"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "rear_signal",
    "data-name": "rear signal"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "M39.48,83.31a96,96,0,0,0-4.59,21.1c-.91,10.72-2.8,35.78-2.8,40.11s-.54,12.61-.54,12.61,5.95,2,9.56-9.64,4.68-17.13,4.59-28.84,1.36-31.28-6.22-35.34Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-100"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M39.94,83.31a95.7,95.7,0,0,0-4.6,21.1c-.9,10.72-2.79,35.78-2.79,40.11S32,157.13,32,157.13s6,2,9.56-9.64,4.69-17.13,4.59-28.84,1.36-31.28-6.21-35.34Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "M39.87,84.76s-2.3,3.37-4.35,18.57-2.71,52.93-2.71,52.93l1.56-2.14s1.23-38.79,2.38-47.58,1.15-9.62,2.63-15,1.56-5.1,1.56-5.1l-1.07-1.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M41.14,130.54a3.3,3.3,0,0,0-1.89-.7c-1.29-.13-1.78-.87-2.44-2.28a8.35,8.35,0,0,0-1.62-2.44,17.25,17.25,0,0,1-1.32-1.82h5.66a1.85,1.85,0,0,1,2.07,1.82,43.9,43.9,0,0,1-.46,5.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M37.42,139.18a13.38,13.38,0,0,1-2.23,4.38c-1.44,1.66-3.06,3.35-3.06,3.35s2.9.33,4.26-.87a15.81,15.81,0,0,0,3.68-6.45c.58-2.19,1.28-8.22,1.28-8.22s-1.49,9.42-3.93,7.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M32.3,147.05l4,2.14s2.62-.1,3.61-1.32a16.1,16.1,0,0,0,1.81-4.41,2.39,2.39,0,0,1-1.26-.37,3.47,3.47,0,0,0-1.44-.47s-1.81,5.44-6.76,4.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M32.49,156.57a13.53,13.53,0,0,0,2.36-3.79c.73-2,1.26-3.55,1.26-3.55a6.28,6.28,0,0,0,3.28-.73c1.3-.85,2.19-3.89,2.19-3.89s-3,12.62-9.09,12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M38.49,127.52c-2.29,0-4.15.19-4.15.42s1.86.42,4.15.42c1.09,0,2.08,0,2.82-.11v-.62c-.75-.07-1.73-.11-2.82-.11Zm0-1.84c-2.29,0-4.15.19-4.15.42s1.86.43,4.15.43c1.08,0,2.06,0,2.8-.11,0-.22,0-.43,0-.63-.74-.07-1.71-.11-2.79-.11Zm0,16.56c-2.29,0-4.15.19-4.15.42s1.86.43,4.15.43h.17c.16-.27.3-.55.44-.85Zm0-1.84c-2.29,0-4.15.19-4.15.42s1.86.43,4.15.43l1,0,0-.07c.07-.24.13-.49.2-.74l-1.21,0Zm0-1.84c-2.29,0-4.15.19-4.15.42s1.86.43,4.15.43c.52,0,1,0,1.46,0,.06-.26.12-.52.17-.79-.5,0-1,0-1.63,0Zm0-1.84c-2.29,0-4.15.19-4.15.42s1.86.43,4.15.43c.66,0,1.29,0,1.84,0,.05-.25.09-.5.13-.75-.58,0-1.25-.05-2-.05Zm0-1.84c-2.29,0-4.15.19-4.15.42s1.86.43,4.15.43c.79,0,1.52,0,2.15-.06,0-.25.07-.48.1-.73-.65,0-1.42-.06-2.25-.06Zm0-1.84c-2.29,0-4.15.19-4.15.42s1.86.43,4.15.43c.9,0,1.72,0,2.4-.08,0-.23.06-.46.08-.69-.69-.05-1.55-.08-2.48-.08Zm0-1.84c-2.29,0-4.15.19-4.15.42s1.86.43,4.15.43c1,0,1.89,0,2.6-.1l.06-.65c-.72-.07-1.64-.1-2.66-.1Zm0-1.84c-2.29,0-4.15.19-4.15.42s1.86.43,4.15.43c1.06,0,2,0,2.75-.11q0-.33,0-.63c-.73-.07-1.7-.11-2.78-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "M33.85,122.65s4.28.1,5.48.18,1.78.13,2.16.74-.51-.69.1-1.22a29.6,29.6,0,0,1,3.24-1.91l-5.89,0-5.09,2.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M35.56,103s1.75,1.11,2.53,5.39.37,5.42.48,7.47a37.22,37.22,0,0,1-.11,4.49,5,5,0,0,1,1.64-.26c1,0,1.48-3.19,1.59-5.27s0-7.59-.7-9.44A7.47,7.47,0,0,0,39.65,103l-4.09,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "M35.94,101.9s4.19-1.15,5.09-3.23a28.44,28.44,0,0,0,1.63-5.83c.22-1.27.3-1.27.3-1.27s.41,6.17-.37,7.77-1.79,1.45-1.79,1.45l3.35.52s-2-.19-2.6.33-5.58.26-5.61.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M39.8,84.25s2.45,5.09,2.64,6.06A4.28,4.28,0,0,0,43.7,92.5c.6.67.56,3.94.56,3.94s0,2.23.15,2.64.22,2.15.22,2.15.15-7.06-.22-8.77-2.49-7.28-4.61-8.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M44.81,103.94a14.27,14.27,0,0,1-.6,4,28.26,28.26,0,0,0-1.05,3.37s.38,1.65.79,4,.86,5.1.86,5.1-.11-10.38,0-16.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M39.25,130.13a1.43,1.43,0,1,1-1.41-1.45A1.43,1.43,0,0,1,39.25,130.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M37.88,129.84a.61.61,0,0,1-1.21,0,.61.61,0,1,1,1.21,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M40.45,107.38c-2.35,0-4.25.17-4.25.38s1.9.38,4.25.38,4.25-.17,4.25-.38-1.9-.38-4.25-.38Zm-.82,12.5c-2.35,0-4.25.17-4.25.38s1.9.38,4.25.38,4.25-.17,4.25-.38-1.9-.38-4.25-.38Zm.13-2.9c-2.35,0-4.25.17-4.25.38s1.9.38,4.25.38,4.25-.17,4.25-.38-1.9-.38-4.25-.38Zm.43-2.88c-2.35,0-4.25.17-4.25.38s1.9.38,4.25.38,4.26-.17,4.26-.38-1.91-.38-4.26-.38ZM40,110.92c-2.35,0-4.25.17-4.25.38s1.9.38,4.25.38,4.25-.17,4.25-.38-1.9-.38-4.25-.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "M33.31,122.92C32.6,132.53,32,142,32,144.52c0,.93,0,2-.07,3.23,3.72-.56,4.5-1.48,6.65-3.78,2.7-2.88,3.6-12.61,3.78-17.12s-2.25-3.79-2.25-3.79l-6.77-.14Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "34.98 102.48 45.57 102.48 45.57 102.1 34.98 102.1 34.98 102.48 34.98 102.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-98",
    points: "34.98 102.48 45.57 102.48 45.57 102.87 34.98 102.87 34.98 102.48 34.98 102.48"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-105"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M39.48,83.31a96,96,0,0,0-4.59,21.1c-.91,10.72-2.8,35.78-2.8,40.11s-.54,12.61-.54,12.61,5.95,2,9.56-9.64,4.68-17.13,4.59-28.84,1.36-31.28-6.22-35.34Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-107"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-108",
    d: "M38.8,83.89s-.55,1.52-1.27,4c7.25,4.39,5.84,23.6,5.94,35.16.08,11.72-1,17.22-4.6,28.84l-.12.36a26.62,26.62,0,0,0,1.67-4.19c3.6-11.63,4.69-17.13,4.59-28.84s1.36-31.28-6.21-35.33Z"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "window"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-109",
    d: "M243.11,127.58l-1.82-46.66s26.87-3.7,50.89,12.32,47.06,36.7,47.06,36.7,2.59,5.48-1.87,5.27-94.26-7.63-94.26-7.63Zm62.41,2.81-59.76-5.19-1.95-42S268.76,82,285,91.37s17.67,12.18,17.67,12.18l2.82,26.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M306.69,131.28l-62-5.39-2-43.61s25.89-1.25,42.78,8.5,18.33,12.65,18.33,12.65l2.93,27.85Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-110"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M243.88,108.73c21.45,1.49,42.3,3.31,61,5.3l-1.11-10.6s-1.45-2.89-18.33-12.65-42.78-8.5-42.78-8.5l1.23,26.45Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M303.75,109.93c3.13,1.06,2.66,9.58,4.11,9.58,4.07,0,4,2.07,4,7.74,0,2.7-1.92,2.15-6.86,1.71-3.2-.28-9.49-.12-10-2.59-.61-3.19-1.83-14.64,1.68-16.07,1.73-.71,5.57-.68,7.07-.37Z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "side_details",
    "data-name": "side details"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M116.9,168.9a32.26,32.26,0,0,1,7.34,7l18.91.81,103.75,3.67,57.75,2.13-1-4.76-71.21-3.59-89.21-4-26.29-1.72,0,.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M116.92,168.65a32.08,32.08,0,0,1,7.72,7.26l18.51.79,103.75,3.67,57.75,2.13-1-4.76-71.21-3.59-89.21-4-26.29-1.72v.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M116.88,169.15a32.38,32.38,0,0,1,7,6.72l19.31.83,103.75,3.67,57.75,2.13c2.36,0,4.31-.43,4.3-1.23s-1.49-3.11-5.31-3.53l-71.21-3.59-89.21-4-26.29-1.72-.05.68Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-112"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M131.94,201.55c.11,1.36.16,2.72.17,4.1a5,5,0,0,0,0,1.59c.3.6,1.78.35,2.63.36,8.73.06,17.45,0,26.18,0q29,.09,57.9.21,27.13.09,54.29.22c9.78,0,19.56,0,29.34.07,2,0,4,0,6,0l3.54.05a1.5,1.5,0,0,1,.72.26,3.22,3.22,0,0,0,.8-.23c2,0,4,.1,6,.1,1,0,1.91,0,2.87,0,.8,0,.51-.89.51-1.59,0-1.78,0-3.49.06-5.18Zm253.57,0a6.7,6.7,0,0,0,.24,2.43c.52,1.43,3.22,1,4.5.89l4.28-.19v-3.13Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-114"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M358.24,120.5c.16-.09.59-.22.42-.43-.34-.43-1.5-.07-2,0,.16-.15,1.31-.75,1-1.11s-1.78.32-2,.39a27.91,27.91,0,0,1-3,1,25,25,0,0,0,5.58.19Zm-17.18-2c-.86-.63-1.68-1.3-2.41-1.78-7.62-5-15.3-10-22.71-15.39-7.09-5.12-14.43-9.91-21.8-14.59,1.34-1,2-.79.31-1.79a18,18,0,0,1,3.23-.91c-1.84-1-3.67-2-5.52-2.93-.94-.51-4.2-1.31-4.36-2.18h.14c-.32-1-2.62-1.46-3.64-1.77l-6-1.81a60.67,60.67,0,0,0-9.4-1.68c-.11.58-.69,0-.89,0a20.31,20.31,0,0,0-2.37-.38c-2.13-.25-4.25-.55-6.38-.69-5.07-.34-10.14-.7-15.22-.91L240,71.54c-.18,0-.24.07-.36.08s.13.19-.31.18a.76.76,0,0,1-.61-.31,38.2,38.2,0,0,0-5.77-.23c-4.94-.12-9.87-.29-14.81-.37l-8.78-.14-4-.07c-.71,0-.82.26-1.35.25s-.84-.28-1.55-.29l-3.73,0-9.57-.11c-9.54-.11-19.07-.07-28.6,0-18.33,0-36.67.4-55,.72l-17.26.35-11,.23-3.72.07a15.57,15.57,0,0,1-2.53.33v-.27c-3.48,0-7,.12-10.45.22l-7,.21c-.9,0-1.8.1-2.71.15s-1.34.35-2.06.41a13.9,13.9,0,0,0-1.38-.21c-.93,0-1.86.22-2.78.33-1.86.23-3.71.45-5.56.72-.62.09-2.29,0-2.74.44a8.56,8.56,0,0,0-.89,2.41C35.14,77.47,33,79,33.82,80c-1.39.45,2.08.13,2.07.16-.27.88,2.07,1.34,2.78,1.52,2,.51,5.23,2.32,5,4,1.1,4.25,1.78,5.35,2.75,11.67l.83,6.27c9,0,6,0,19.17.09.92,0,2.54.57,3.89-2.12a77.63,77.63,0,0,1,6.94-11.44c5.84-7.89,13.38-9.81,34.69-10.44S145,79.18,145,79.18l76.93.54A5.47,5.47,0,0,1,226,80.81l-.09-.26c.83.69,1.45,1.23,1.63,3.61s.42,11.14.55,20.64c0,2,.8,2.94,1.21,3l1.36.09c.82.05.66-5.36,1.49-5.31,1.11.07,3.2,5.61,4.31,5.68a7.75,7.75,0,0,0,7.16-5.18l-1-20.76.39,0v0s25.8-2,42.77,8.51,18.25,11.39,18.25,11.39l1.24,11.93c13.2,1.42,25.3,2.91,35.76,4.44ZM226.52,81.37l.07.09-.07-.09Zm.17.24.07.11-.07-.11Zm.16.27a.61.61,0,0,1,.07.14.61.61,0,0,0-.07-.14Zm.07.14a.61.61,0,0,1,.07.14.61.61,0,0,0-.07-.14Zm.08.15a1,1,0,0,0,.07.15,1,1,0,0,1-.07-.15Zm.07.16.06.15-.06-.15Zm.07.16a1,1,0,0,1,.05.16,1,1,0,0,0-.05-.16Zm.06.18a.75.75,0,0,1,.05.16.75.75,0,0,0-.05-.16Zm.05.17.06.18a1.89,1.89,0,0,0-.06-.18Zm-1-.71a5.84,5.84,0,0,0-3.47-.65L145.88,81s-11.76-.2-33.08.43S84,83.93,78.11,91.82a74,74,0,0,0-5.8,9.26c-1.65,3.09.84,2.57,1.61,2.57,21.14.11,45.35.34,68.26.76.61,0,.49-3.06,1.09-3s1.23,3.1,2.24,3.11c9.69.19,19.12.41,27.94.68,16.66.5,34,1.3,51.33,2.34.69,0,1.67-.88,1.93-2.71-.12-9.84-.3-20.77-.42-22.38s0-.18,0-.27Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M116.9,169.27a32.26,32.26,0,0,1,7.34,7l18.91.81,103.75,3.67,57.75,2.13-1-4.76-71.21-3.59-89.21-4-26.29-1.71,0,.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M116.92,169a32.08,32.08,0,0,1,7.72,7.26l18.51.79,103.75,3.67,57.75,2.13-1-4.76-71.21-3.59-89.21-4-26.29-1.71V169Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-116",
    d: "M116.88,169.53a32.1,32.1,0,0,1,7,6.71l19.31.83,103.75,3.67,57.75,2.13c2.36,0,4.31-.43,4.3-1.23s-1.49-3.1-5.31-3.53l-71.21-3.59-89.21-4-26.29-1.71-.05.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-117",
    d: "M130.05,169.7l-7.53-.49c-.1.08-.16.14-.16.17s3.09,3.13,4.7,5.14c.43.06-3-3.36,6.11-2.52,30.62,1.73,173.62,8.48,173.25,8a4.3,4.3,0,0,0-2.69-1.14L136.9,171.18c-2-.09-4.41.37-6.85-1.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "M58.4,136.32a3.29,3.29,0,0,1,2-.46l17,.62,63.93,3L232.86,147a645.66,645.66,0,0,1,72.86,10c3.84.83,6.09,1.54,6.64,2.11-76.25-9.2-159.88-15.81-252.26-19.4l-1.7-3.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M312.36,159.13a.47.47,0,0,1,.13.25c-.1.61-2.71.45-5.87.13l-73.46-5.95-91.47-5.86-82.81-4.16c-2.14,0-3-.57-2.65-1.62l3.87-2.19c92.38,3.59,176,10.2,252.26,19.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M234.4,158.85l7.39.59s4.14.1,4.44,7c.07,1.76.19,4.54.32,7.7l-.44,0c-.11-2.72-.21-5.09-.28-6.65-.29-6.89-4.44-7-4.44-7l-7-.56,0-1.06Zm12.18,16.08.09,2.18h-.44l0-1.14-12.05-.45v-.8l12,.45v-.25l.44,0Zm.26,6.55c.3,7.32.57,14.23.57,14.23H247c-.09-2.19-.31-7.57-.53-13.19L234,182.05l0-1.05,12.8.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M233.78,157.76l8.15.65h0c.27,0,4.82.33,5.15,8l1.3,30.53,0,.29h-.29l-15-.15h-.27v-.28l.66-38.73v-.29l.29,0Zm8.11,1.19-7.86-.63-.65,38.17,14.45.15-1.3-30.25c-.31-7.34-4.62-7.44-4.63-7.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M38.55,82.72c.16-.24.32-.53.49-.84,1.39-2.58,3.78-7,17.47-7.45l49.07-1.64h0L145,72h0c.15,0,52.29,0,64.5.19l1.44,0c12.94.2,42.58.66,51.73,2.06,9.55,1.47,21.21,5.65,21.24,5.66l-.55,1.55s-11.55-4.14-20.94-5.58c-9.08-1.4-38.61-1.86-51.5-2.06h0l-1.44,0c-11.8-.19-64.33-.19-64.48-.19h0l-39.32.76h0L56.56,76.07c-12.74.43-14.85,4.32-16.09,6.59-.2.37-.38.7-.57,1l-1.35-.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M344.59,120.06a39.46,39.46,0,0,0,10.48,5.71c2.49.78,6.72,2.38,11.31,4.21,5.23,2.09,10.9,4.47,15,6.28,3.86,1.72,7.56,3.39,10.78,5.2a29.65,29.65,0,0,1,7.95,6l-.42.36a29.24,29.24,0,0,0-7.79-5.89c-3.2-1.8-6.89-3.47-10.74-5.18-4.12-1.82-9.79-4.2-15-6.27-4.57-1.82-8.79-3.42-11.27-4.2a40.27,40.27,0,0,1-10.65-5.8l.33-.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "M366.55,127.57s26.63,10.2,33.2,15.49,8.86,9.06,9.59,11.54,2.69,10.26,4.29,11.87a5.69,5.69,0,0,0,3.73,1.48c-1.16-1-3.06-5.23-3.93-7.46s-3.23-7.52-4-9.76c-.32-.91,0-1.33.59-1.51a16,16,0,0,0-4.13-4.14c-5-3.42-22.2-12.41-39.31-17.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "M46.31,123.47s160.66,8.08,214,12.6,124.45,12,124.45,12c-2.76-1.72,14.71-1.51,9.52-3.55,0,0-109.72-13.58-348-21Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-59",
    points: "330.41 122.49 348.85 123.27 349.75 123.86 331.34 123.11 330.41 122.49 330.41 122.49"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-120"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "M64.52,183.9s1.72-8.27,3.7-11.62,3-4.82,3-4.82l-2.07-1.89s10.85-10.33,26-11.19,25.13,4.13,30.12,8.78a46,46,0,0,1,6.17,7.86l-7.82-.19a28.3,28.3,0,0,0-8.84-5.78c-14.12-5.94-24.81-3.77-32,.19s-12,11.6-13.06,15-2,5.94-2,5.94l-3.27-2.32Zm70.67-6.73a50.37,50.37,0,0,1,4.63,10c1.29,5.07,3.44,8.34,8.09,9s13.25.77,13.25.77l-22-.09s-3.36.26-5.42-6.28c-1.07-3.39-2.33-8.53-5.27-13.52l6.75.17Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-122"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "M315.14,197.7a2.53,2.53,0,0,0,2.23-2.38c.36-2.3,1.73-21.35,12.51-30.77s20.06-9.56,29-9.13,22.07,7.19,26.31,13.73,6.48,16.68,6.83,19.7,1,13.37,1,13.37a5.24,5.24,0,0,1-2.87.72c-1.66-.07-1.59-1.65-1.59-2.87s.72-15-5.6-25.74-19.84-14-27-13.8-21.13,3.52-27.1,14.37-6.68,19.63-7.55,22.36-2.3,2.23-6.11.44Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "M70.1,164.59l-1,.55S80,153.41,95.15,152.55s25.13,4.13,30.12,8.78c2.18,2,1.49,2.95,0,1.67-5-4.65-15-9.64-30.12-8.77-12.53.71-22.12,7.9-25.05,10.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "M329.88,163.61c10.79-9.41,20.06-9.56,29-9.13s22.07,7.19,26.31,13.73,6.48,16.68,6.83,19.7,1,13.37,1,13.37l-.07,0c-.17-2.71-.65-9.88-.94-12.31-.35-3-2.58-13.16-6.83-19.7s-17.39-13.3-26.31-13.73-18.18-.29-29,9.13c-3.79,3.18-6.59,7.72-8.73,13.13a28.67,28.67,0,0,1,8.73-14.23Zm58.67,36.28c0-.26,0-.52,0-.77s0-.63,0-1.32c0,.95,0,1.67,0,2.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M224.69,126.16l-155-4.52s-4.72,0-5.76-3.22a8.36,8.36,0,0,0,4.52,1.46l155,4.51a3.74,3.74,0,0,0,3.53-3.58s-.29-33-.69-38.41a6.35,6.35,0,0,0-.39-1.85,4.92,4.92,0,0,1,1.63,3.61c.39,5.44.69,38.41.69,38.41a3.75,3.75,0,0,1-3.53,3.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M135.07,193.69a11.89,11.89,0,0,0,9.26,4.39c6.1,0,174.7,1.57,174.7,1.57L315,197.14l-171-2s-6.89-.62-8.92-1.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M233.48,197l79,.66,2.1-65.95-4.47-25.92A89.1,89.1,0,0,0,302,98.2a89.76,89.76,0,0,1,8.82,8.17l4.47,25.92-2.1,66-79.7-.66V197Zm-1.1,1.08h-.67v-.55l.77-70.11-1-49.87v-.47l.47-.07s4.05-.18,20.57.35a80,80,0,0,1,23.07,4.36,98.28,98.28,0,0,1,22,11.74c1.79,1.25,3.49,2.56,5,3.84-1.37-1.11-2.84-2.23-4.38-3.3a97.87,97.87,0,0,0-22-11.74,80.05,80.05,0,0,0-23.08-4.36c-16.51-.52-20.55-.36-20.56-.35l-.47.07v.47l1,49.87-.77,70.11Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-78",
    points: "331.25 123.07 349.69 123.86 350.58 124.44 332.18 123.69 331.25 123.07 331.25 123.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M310.25,105.42a89.39,89.39,0,0,0-12.71-11,96.5,96.5,0,0,0-21.76-11.61,79,79,0,0,0-22.73-4.3c-13.42-.43-18.42-.57-19.89-.42l1,49.38v0l-.76,68.91h-.48l.77-69.57v0l-1-49.38c1.47-.15,6.47,0,19.89.42a79.25,79.25,0,0,1,22.73,4.3A96.61,96.61,0,0,1,297.07,93.8a88.82,88.82,0,0,1,13.14,11.43l0,.19Zm3.34,93.44-80.79-.68h-.55v-.66h.06l80.79.68h.53l0-.54,2.12-66.55V131l-4.51-26.1.34.36.11.12,0,.16,4.51,26.12v.11l-2.11,66.55,0,.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "M64.66,119.92c-1-1.16-1.47-3-.1-6,3.57-7.83,6.82-16,12.67-23.85s13.38-9.81,34.69-10.44S145,79.18,145,79.18l76.93.54s4.31-.68,5.39,3.3c-1.64-2-4.51-1.54-4.51-1.54L145.88,81s-11.77-.2-33.08.43S84,83.93,78.11,91.82s-9.1,16-12.67,23.85a7.05,7.05,0,0,0-.78,4.25Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-125",
    points: "69.91 136.52 140.6 139.65 140.6 141.28 69.91 138.14 69.91 136.52 69.91 136.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-126",
    d: "M69.91,136.23l70.69,3.14h.29v2.19h-.29l-70.69-3.14h-.28v-2.19Zm70.41,3.69-70.13-3.11v1.06L140.32,141v-1.06Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-127",
    points: "69.91 136.52 71.97 136.61 71.97 138.23 69.91 138.14 69.91 136.52 69.91 136.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-127",
    points: "136.56 139.47 140.6 139.65 140.6 141.28 136.56 141.1 136.56 139.47 136.56 139.47"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-128",
    transform: "translate(83.74 115.19) scale(1.1 1)"
  }, "T", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-129",
    x: 9.38,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-130",
    x: 21.11,
    y: 0
  }, "\u015F"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-131",
    x: 29.38,
    y: 0
  }, "\u0131ma"))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M190.61,91.29v24.92h.11c.54,0,1.07,0,1.61,0,.31,0,.43-.13.47-.46.19-1.69.39-3.37.6-5.05.39-3.27.75-6.55,1.21-9.81a26.41,26.41,0,0,1,.85-3.25c1.14,0,2.25.09,3.37.17,2.17.16,4.35.3,6.51.54a12.32,12.32,0,0,1,11.35,8,73.13,73.13,0,0,1,3.89,11.33,1.2,1.2,0,0,1,0,.65,1.71,1.71,0,0,0,.22,1.72,4.32,4.32,0,0,1,.28.53c-.38.39-.74.79-1.13,1.16a.92.92,0,0,1-.52.21c-.83,0-1.66,0-2.49,0a.56.56,0,0,0-.4.32c-.68,2.17-2.11,3.4-4,3.39s-3.24-1.27-3.88-3.43l-.1-.27h-16.5a5.38,5.38,0,0,1-1.46,2.69V132h37.28V91.29Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M217.75,118.3c.32,0,.64,0,1.06,0-.57-1-1.07-1.89-1.58-2.77-.39-.69-.39-.69-1.13-.28.45.95.9,1.89,1.36,2.83A.44.44,0,0,0,217.75,118.3Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M192.07,122h16.5l.1.27c.64,2.16,2.06,3.42,3.88,3.43s3.28-1.22,4-3.39a.56.56,0,0,1,.4-.32c.83,0,1.66,0,2.49,0a.92.92,0,0,0,.52-.21c.39-.37.75-.77,1.13-1.16a4.32,4.32,0,0,0-.28-.53,1.71,1.71,0,0,1-.22-1.72,1.2,1.2,0,0,0,0-.65,73.13,73.13,0,0,0-3.89-11.33,12.32,12.32,0,0,0-11.35-8c-2.16-.24-4.34-.38-6.51-.54-1.12-.08-2.23-.12-3.37-.17a26.41,26.41,0,0,0-.85,3.25c-.46,3.26-.82,6.54-1.21,9.81-.21,1.68-.41,3.36-.6,5.05,0,.33-.16.48-.47.46-.54,0-1.07,0-1.61,0h-.11l-1.22,5.27C190.07,120.85,190.33,122,192.07,122Zm20.54,1.47a2.44,2.44,0,0,1,0-4.85,2.24,2.24,0,0,1,2.1,2.41A2.27,2.27,0,0,1,212.61,123.49Zm-.48-21.17a.56.56,0,0,1,.62,0,12,12,0,0,1,2.56,3.5c.67,1.35,1.25,2.77,1.87,4.17,0,.1.07.21.13.4-.1.11-.19.32-.33.36a.51.51,0,0,1-.45-.19,7.45,7.45,0,0,1-.4-1,19,19,0,0,0-3.91-6.61C212,102.81,211.89,102.52,212.13,102.32ZM206,99.63c0-.18.24-.32.31-.41a13.06,13.06,0,0,1,4.29,1.47c.14.09.18.41.26.63-.19.07-.43.27-.56.2a13.88,13.88,0,0,0-3.9-1.34C206.11,100.13,205.89,100,206,99.63Zm-11,6.88c.21-1.7.41-3.4.62-5.1,0-.2.07-.4.11-.66,1.42.09,2.81.16,4.2.27.13,0,.28.26.34.44.4,1.16.74,2.35,1.19,3.48a4.6,4.6,0,0,0,2.94,2.85c3.91,1.33,7.79,2.8,11.7,4.18a4.9,4.9,0,0,0,1.53.17.51.51,0,0,1,.56.45c.48,1.68,1,3.34,1.49,5a1.3,1.3,0,0,1,0,.73c-.22.66-.34,1.56-.78,1.88s-1.22.1-1.85.11l-.41,0a5.1,5.1,0,0,0-1.48-2.89c-2.19-2-5.41-1-6.36,2-.14.44-.32.54-.69.52l-10.77-.46a1,1,0,0,1-.57-.23c-.91-.75-1.82-1.51-2.7-2.31a.93.93,0,0,1-.25-.68C194.19,113.05,194.6,109.78,195,106.51Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M196.75,119.31a1,1,0,0,0,.57.23l10.77.46c.37,0,.55-.08.69-.52.95-3,4.17-4.07,6.36-2a5.1,5.1,0,0,1,1.48,2.89l.41,0c.63,0,1.4.22,1.85-.11s.56-1.22.78-1.88a1.3,1.3,0,0,0,0-.73c-.49-1.69-1-3.35-1.49-5a.51.51,0,0,0-.56-.45,4.9,4.9,0,0,1-1.53-.17c-3.91-1.38-7.79-2.85-11.7-4.18a4.6,4.6,0,0,1-2.94-2.85c-.45-1.13-.79-2.32-1.19-3.48-.06-.18-.21-.43-.34-.44-1.39-.11-2.78-.18-4.2-.27,0,.26-.08.46-.11.66-.21,1.7-.41,3.4-.62,5.1-.41,3.27-.82,6.54-1.21,9.81a.93.93,0,0,0,.25.68C194.93,117.8,195.84,118.56,196.75,119.31Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M212.59,118.64a2.45,2.45,0,1,0,2.1,2.41A2.24,2.24,0,0,0,212.59,118.64Zm0,4a1.54,1.54,0,0,1-1.43-1.62,1.53,1.53,0,0,1,1.42-1.63,1.5,1.5,0,0,1,1.42,1.61A1.53,1.53,0,0,1,212.59,122.69Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M216.13,109.63a7.45,7.45,0,0,0,.4,1,.51.51,0,0,0,.45.19c.14,0,.23-.25.33-.36-.06-.19-.09-.3-.13-.4-.62-1.4-1.2-2.82-1.87-4.17a12,12,0,0,0-2.56-3.5.56.56,0,0,0-.62,0c-.24.2-.12.49.09.7A19,19,0,0,1,216.13,109.63Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M206.38,100.18a13.88,13.88,0,0,1,3.9,1.34c.13.07.37-.13.56-.2-.08-.22-.12-.54-.26-.63a13.06,13.06,0,0,0-4.29-1.47c-.07.09-.27.23-.31.41C205.89,100,206.11,100.13,206.38,100.18Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M212.58,119.44a1.53,1.53,0,0,0-1.42,1.63,1.43,1.43,0,1,0,2.84,0A1.5,1.5,0,0,0,212.58,119.44Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-46",
    cx: 213.22,
    cy: 120.14,
    r: 5.53
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M213.14,115.65a4.33,4.33,0,1,0,4.33,4.32A4.31,4.31,0,0,0,213.14,115.65Zm0,6.28a2,2,0,1,1,2-2A2,2,0,0,1,213.14,121.93Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M218.79,113.16l1.69,3c-.45,0-.79,0-1.13,0a.49.49,0,0,1-.32-.23c-.49-1-1-2-1.45-3C218.37,112.42,218.37,112.42,218.79,113.16Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M159.36,115.13l-6.61.62h8.72v2.06l-13.73,1h13.73v2L144.23,122h24.15a.14.14,0,0,0,0-.07h7.28a.25.25,0,0,1,0,.07h4.94a1.15,1.15,0,0,0,1,1.14H187a1.15,1.15,0,0,0,1-1.14h5.92v-5h0v-1.9Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-46",
    cx: 171.66,
    cy: 121.19,
    r: 4.95
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-46",
    cx: 171.73,
    cy: 120.54,
    r: 5.03
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M171.66,116.45a3.94,3.94,0,1,0,3.94,3.94A3.94,3.94,0,0,0,171.66,116.45Zm0,5.72a1.78,1.78,0,1,1,1.78-1.78A1.78,1.78,0,0,1,171.66,122.17Z"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "cls-134",
    transform: "translate(155.15 115.51) rotate(-5.51) scale(1.1 1)"
  }, "c\u0131m")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAraclar14);
export default __webpack_public_path__ + "static/media/araclar-14.2cb144d6c175dfb21cb7f5fe15ee85d2.svg";
export { ForwardRef as ReactComponent };